export default {
  // --------------------------------------------------------------------------
  // temp
  featureBeingImplemented: "Funkcionalnost v izdelavi",

  // --------------------------------------------------------------------------
  // layout
  logout: "Odjava",
  "account.toggle": "Uporabniški račun",

  // --------------------------------------------------------------------------
  "navigate.back": "Nazaj",
  "admin.csv.title": "Uvoz CSV",
  "admin.csv.description": "Uvoz podatkov različnih tipov iz CSV datoteke",

  "common.new": "novo",

  yes: "Da",
  no: "Ne",

  HORSES: "kopitarji",
  PIGS: "prasici",
  SMALL_LIVESTOCK: "drobnica",
  CATTLE: "govedo",

  horses: "Kopitarji",
  pigs: "Prašiči",
  small_livestock: "Drobnica",

  AKTIVNA: "Aktivna",
  NEAKTIVNA: "Neaktivna",

  AKTIVEN: "Aktiven",
  NEAKTIVEN: "Neaktiven",

  AKTIVNO: "Aktivno",
  NEAKTIVNO: "Neaktivno",

  "csv.summary.title": "Povzetek uvoza",
  "csv.summary.nonBlankRows": "Neprazne vrstice",
  "csv.summary.headerRows": "Glava",
  "csv.summary.commentRows": "Komentarji (#)",
  "csv.summary.dataRows": "Podatkovne vrstice",
  "csv.summary.successCount": "Uspešno uvoženo",
  "csv.summary.errorRowCount": "Vrstice z napako",
  "csv.summary.errorCount": "Napak skupaj",
  "csv.summary.warning": "Opozorilo",
  "csv.summary.mismatchWarning":
    "Število podatkovnih vrstic ({{dataRows}}) se ne ujema z vsoto uspešnih + napačnih ({{processedKnown}}).",
  "csv.summary.nonBlankVsSuccessWarning":
    "Informativno: neprazne vrstice ({{nonBlankRows}}) niso enake številu uspešno uvoženih ({{successCount}}). To je običajno, če datoteka vsebuje glavo, komentarje ali vrstice z napako.",
  "csv.summary.headerProcessedHint":
    "Videti je, da je bila glava CSV obdelana kot podatki (npr. 'species'). Preveri skip-header / parser nastavitev za ta endpoint.",

  "csv.errors.title": "Napake po vrsticah",
  "csv.errors.insufficientFields":
    "Vrstica {{row}}: premalo stolpcev (pričakovano najmanj {{expected}}, prejeto {{actual}}).",
  "csv.errors.fieldRequired": 'Vrstica {{row}}: polje "{{field}}" je obvezno.',
  "csv.errors.animalNotFoundByEarTag":
    'Vrstica {{row}}: žival ({{species}}) z ušesno številko "{{usesnaStevilka}}" ne obstaja.',
  "csv.errors.fieldDigitsExact":
    'Vrstica {{row}}: polje "{{field}}" mora imeti točno {{digits}} števk (prejeto: {{value}}).',
  "csv.errors.fieldDateFormat":
    'Vrstica {{row}}: polje "{{field}}" mora biti v formatu dd.MM.yyyy (prejeto: {{value}}).',
  "csv.errors.fieldNumber":
    'Vrstica {{row}}: polje "{{field}}" mora biti število (prejeto: {{value}}).',
  "csv.errors.usesnaStevilkaExists":
    'Vrstica {{row}}: ušesna številka "{{usesnaStevilka}}" že obstaja.',
  "csv.preview.title": "Predogled CSV (z oznakami vrstic)",

  "csv.debug.title": "Backend napaka (raw)",

  "csv.upload.dog.analize.genomSnp": "Analize – genom SNP",
  "csv.upload.dog.analize.genomSnp.description":
    "Uvoz CSV za rezultate genom SNP analize.",

  "csv.upload.dog.analize.genotipizacija": "Analize – genotipizacija",
  "csv.upload.dog.analize.genotipizacija.description":
    "Uvoz CSV za podatke genotipizacije.",

  "csv.upload.dog.analize.labPosiljka": "Analize – laboratorijska pošiljka",
  "csv.upload.dog.analize.labPosiljka.description":
    "Uvoz CSV za evidenco laboratorijskih pošiljk.",

  "csv.upload.dog.izlocitev.izlocitev": "Izločitev",
  "csv.upload.dog.izlocitev.izlocitev.description":
    "Uvoz CSV za dogodke izločitve.",

  "csv.upload.dog.kotitve.kotitev": "Kotitve – kotitev",
  "csv.upload.dog.kotitve.kotitev.description": "Uvoz CSV za dogodke kotitve.",

  "csv.upload.dog.kotitve.prasitev": "Kotitve – prasitev (prašiči)",
  "csv.upload.dog.kotitve.prasitev.description":
    "Uvoz CSV za dogodke prasitve (prašiči).",

  "csv.upload.dog.meritve.drob.dolocitevKakovostnegaRazreda":
    "Meritve (drob) – določitev kakovostnega razreda",
  "csv.upload.dog.meritve.drob.dolocitevKakovostnegaRazreda.description":
    "Uvoz CSV za določitev kakovostnega razreda (drob).",

  "csv.upload.dog.meritve.drob.misicaHrbet": "Meritve (drob) – hrbtna mišica",
  "csv.upload.dog.meritve.drob.misicaHrbet.description":
    "Uvoz CSV za meritve hrbtne mišice (drob).",

  "csv.upload.dog.meritve.drob.telesnaOcena": "Meritve (drob) – telesna ocena",
  "csv.upload.dog.meritve.drob.telesnaOcena.description":
    "Uvoz CSV za telesno oceno (drob).",

  "csv.upload.dog.meritve.drob.volna": "Meritve (drob) – volna",
  "csv.upload.dog.meritve.drob.volna.description":
    "Uvoz CSV za podatke/meritve volne (drob).",

  "csv.upload.dog.mleko.mlecnostKontrola": "Mleko – kontrola mlečnosti",
  "csv.upload.dog.mleko.mlecnostKontrola.description":
    "Uvoz CSV za podatke kontrole mlečnosti.",

  "csv.upload.dog.mleko.molza": "Mleko – molža",
  "csv.upload.dog.mleko.molza.description": "Uvoz CSV za podatke o molži.",

  "csv.upload.dog.odbira.odbira": "Odbira",
  "csv.upload.dog.odbira.odbira.description": "Uvoz CSV za podatke odbire.",

  "csv.upload.dog.odstavitev.odstavitev": "Odstavitev",
  "csv.upload.dog.odstavitev.odstavitev.description":
    "Uvoz CSV za dogodke odstavitve.",

  "csv.upload.dog.odstavitev.odstavitevPrasic": "Odstavitev (prašiči)",
  "csv.upload.dog.odstavitev.odstavitevPrasic.description":
    "Uvoz CSV za dogodke odstavitve (prašiči).",

  "csv.upload.dog.oznacevanje.oznDrob": "Označevanje (drob)",
  "csv.upload.dog.oznacevanje.oznDrob.description":
    "Uvoz CSV za označevanje drobnice.",

  "csv.upload.dog.oznacevanje.oznPrasic": "Označevanje (prašiči)",
  "csv.upload.dog.oznacevanje.oznPrasic.description":
    "Uvoz CSV za označevanje prašičev.",

  "csv.upload.dog.prasic.mesnatost": "Mesnatost (prašiči)",
  "csv.upload.dog.prasic.mesnatost.description":
    "Uvoz CSV za meritve mesnatosti (prašiči).",

  "csv.upload.dog.prasic.preizkus": "Preizkus (prašiči)",
  "csv.upload.dog.prasic.preizkus.description":
    "Uvoz CSV za podatke preizkusa (prašiči).",

  "csv.upload.dog.prasic.preizkus.meritev": "Preizkus (prašiči) – meritve",
  "csv.upload.dog.prasic.preizkus.meritev.description":
    "Uvoz CSV za meritve v okviru preizkusa (prašiči).",

  "csv.upload.dog.prasic.prodaja": "Prodaja (prašiči)",
  "csv.upload.dog.prasic.prodaja.description":
    "Uvoz CSV za podatke prodaje (prašiči).",

  "csv.upload.dog.prasic.prodaja.prasic": "Prodaja (prašiči) – živali",
  "csv.upload.dog.prasic.prodaja.prasic.description":
    "Uvoz CSV za seznam živali v prodaji (prašiči).",

  "csv.upload.dog.premik": "Premik",
  "csv.upload.dog.premik.description":
    "Uvoz CSV za premike (živali/gospodarstva).",

  "csv.upload.dog.pripusti.pripust": "Pripusti – pripust",
  "csv.upload.dog.pripusti.pripust.description":
    "Uvoz CSV za dogodke pripusta.",

  "csv.upload.dog.seme.prepoved_prodaje": "Seme – prepoved prodaje",
  "csv.upload.dog.seme.prepoved_prodaje.description":
    "Uvoz CSV za evidence prepovedi prodaje semena.",

  "csv.upload.dog.seme.vzorec": "Seme – vzorec",
  "csv.upload.dog.seme.vzorec.description":
    "Uvoz CSV za podatke o vzorcih semena.",

  "csv.upload.dog.testna_postaja.krvnaAnaliza.analiza":
    "Testna postaja – krvna analiza: analiza",
  "csv.upload.dog.testna_postaja.krvnaAnaliza.analiza.description":
    "Uvoz CSV za analize krvnih vzorcev (testna postaja).",

  "csv.upload.dog.testna_postaja.krvnaAnaliza.bolezen":
    "Testna postaja – krvna analiza: bolezen",
  "csv.upload.dog.testna_postaja.krvnaAnaliza.bolezen.description":
    "Uvoz CSV za bolezni/diagnoze (krvna analiza, testna postaja).",

  "csv.upload.dog.testna_postaja.krvnaAnaliza.rezultat":
    "Testna postaja – krvna analiza: rezultat",
  "csv.upload.dog.testna_postaja.krvnaAnaliza.rezultat.description":
    "Uvoz CSV za rezultate krvne analize (testna postaja).",

  // --------------------------------------------------------------------------
  // offline mode
  "connection.offline.notice":
    "Trenutno ste brez povezave. Preverite svojo internetno povezavo.",
  "csv.upload.dog.testna_postaja.naselitev": "Testna postaja – naselitev",
  "csv.upload.dog.testna_postaja.naselitev.description":
    "Uvoz CSV za naselitve v testno postajo.",

  "csv.upload.dog.testna_postaja.odkup.odkup": "Testna postaja – odkup",
  "csv.upload.dog.testna_postaja.odkup.odkup.description":
    "Uvoz CSV za odkupe (glava dokumenta/posla) v testni postaji.",

  "csv.upload.dog.testna_postaja.odkup.zival": "Testna postaja – odkup: živali",
  "csv.upload.dog.testna_postaja.odkup.zival.description":
    "Uvoz CSV za živali v okviru odkupa (testna postaja).",

  "csv.upload.dog.testna_postaja.semeTp": "Testna postaja – seme (TP)",
  "csv.upload.dog.testna_postaja.semeTp.description":
    "Uvoz CSV za podatke o semenu v testni postaji.",

  "csv.upload.dog.testna_postaja.skupina": "Testna postaja – skupina",
  "csv.upload.dog.testna_postaja.skupina.description":
    "Uvoz CSV za skupine v testni postaji.",

  "csv.upload.dog.testna_postaja.spremniDokument":
    "Testna postaja – spremni dokument",
  "csv.upload.dog.testna_postaja.spremniDokument.description":
    "Uvoz CSV za spremne dokumente (testna postaja).",

  "csv.upload.dog.testna_postaja.tehtanje": "Testna postaja – tehtanje",
  "csv.upload.dog.testna_postaja.tehtanje.description":
    "Uvoz CSV za tehtanja (testna postaja).",

  "csv.upload.dog.testna_postaja.tretiranje": "Testna postaja – tretiranje",
  "csv.upload.dog.testna_postaja.tretiranje.description":
    "Uvoz CSV za tretiranja/posege (testna postaja).",

  "csv.upload.dog.vnos.vnosPoreklo": "Vnos – poreklo",
  "csv.upload.dog.vnos.vnosPoreklo.description":
    "Uvoz CSV za vnos podatkov o poreklu.",

  "csv.upload.dog.vnos.vnosUvozZivali": "Vnos – uvoz živali",
  "csv.upload.dog.vnos.vnosUvozZivali.description":
    "Uvoz CSV za vnos uvoza živali.",

  "csv.upload.gen.geneologija": "Genealogija",
  "csv.upload.gen.geneologija.description": "Uvoz CSV za podatke genealogije.",

  "csv.upload.gen.koefSorodstva": "Koeficient sorodstva",
  "csv.upload.gen.koefSorodstva.description":
    "Uvoz CSV za izračune/uvoz koeficientov sorodstva.",

  "csv.upload.rkg.gospodarstvo": "RKG – gospodarstvo",
  "csv.upload.rkg.gospodarstvo.description":
    "Uvoz CSV za podatke gospodarstev (RKG).",

  "csv.upload.rkg.subjekt": "RKG – subjekt",
  "csv.upload.rkg.subjekt.description": "Uvoz CSV za podatke subjektov (RKG).",
  unknownError: "Neznana napaka",

  "csv.upload.buttonLabel": "Uvozi CSV",
  "csv.upload.modalTitle": "Uvoz CSV",
  "csv.selector.label": "Tip uvoza",

  "csv.import.fallbackError": "Vnos podatkov iz CSV ni uspel",
  "csv.import.errorTitle": "Napake",

  "csv.diagnostics.title": "Napake pri uvozu",
  "csv.diagnostics.localCheckTitle": "Lokalni CSV pregled",
  "csv.diagnostics.serverErrorsTitle": "Napake iz strežnika",
  "csv.diagnostics.rowLabel": "Vrstica {row}",
  "csv.diagnostics.generalError": "Splošna napaka",
  "csv.diagnostics.showMore": "Prikaži še {count} vrstic napak",

  "csv.precheck.tooManyColumns":
    "Preveč stolpcev ({actual}), pričakovano {expected}. Možen dodaten ';' ali zamaknjen zapis.",
  "csv.precheck.tooFewColumns":
    "Premalo stolpcev ({actual}), pričakovano {expected}. Manjka vrednost ali separator ';'.",
  "csv.precheck.headerMismatch":
    "Glava stolpca #{index} je '{actual}', pričakovano '{expected}'.",
  "csv.precheck.headerMissing":
    "Glava CSV ni prepoznana. Preveri, ali prva vrstica vsebuje imena stolpcev.",

  "csv.errors.invalidFilePayload": "Invalid file payload",

  "csv.endpoints.dog.prasic.mesnatost.title": "Mesnatost (prašiči)",
  "csv.endpoints.dog.prasic.mesnatost.description":
    "Uvoz CSV za meritve mesnatosti",
  "csv.endpoints.dog.prasic.mesnatost.templateFileName":
    "meat_quality_template.csv",

  // --------------------------------------------------------------------------
  // Main navigation
  "mainNavigation.main-modules.section": "Glavni sklopi",

  "mainNavigation.dashboard.label": "Domov",
  "mainNavigation.dashboard.text": "Glavna nadzorna plošča",
  "mainNavigation.cattle.label": "eGovedo",
  "mainNavigation.cattle.text": "Govedo",
  // The app itself, deliberately NOT "eGovedo" — that is the separate
  // cattle application this module links out to.
  "mainNavigation.cattle.appTitle": "PV Govedo",
  "mainNavigation.small-livestock.label": "eDrobnica",
  "mainNavigation.small-livestock.text": "Ovce in koze",
  "mainNavigation.pigs.label": "ePrašiči",
  "mainNavigation.pigs.text": "Prašiči",
  "mainNavigation.horses.label": "eKopitarji",
  "mainNavigation.horses.text": "Konji in kopitarji",
  "mainNavigation.bees.label": "eČebele",
  "mainNavigation.bees.text": "Čebelnjaki in družine",
  "mainNavigation.gene-bank.label": "Genska banka",
  "mainNavigation.gene-bank.text": "Genski viri in vzorci",

  "mainNavigation.toggle": "Meni",

  "mainNavigation.breeders.section": "Rejci",
  "mainNavigation.breeders.label": "Seznami subjektov",
  "mainNavigation.manage-assignments.label": "Upravljanje dodelitev",
  "mainNavigation.manage-assignments.text": "Kontrolorji in selekcionisti",
  "mainNavigation.breeders.text": "Seznam vseh rejcev",

  "mainNavigation.management.section": "Upravljanje",
  "mainNavigation.reports.label": "Poročila",
  "mainNavigation.reports.text": "Analitika in izpisi",
  "mainNavigation.settings.label": "Administracija",
  "mainNavigation.settings.text": "Šifranti in nastavitve",

  "mainNavigation.profile.label": "Upravljanje profila",
  "mainNavigation.profile.text": "Osebni podatki",

  "mainNavigation.notifications.label": "Obvestila",
  "mainNavigation.notifications.text": "{{count}} nova sporočila",

  "mainNavigation.templates.label": "Predloge",
  "mainNavigation.templates.text": "Upravljanje s predlogami",

  "mainNavigation.placeholders.label": "Ključniki",
  "mainNavigation.placeholders.text": "Upravljanje s ključniki",

  // --------------------------------------------------------------------------

  "admin.title": "Administracija",

  // --------------------------------------------------------------------------

  "admin.activities.title": "Aktivnosti",
  "admin.activities.description": "Pregled aktivnosti v sistemu",
  "admin.activities.opensearch.title": "OpenSearch",
  "admin.activities.opensearch.description": "Iskanje in analiza dnevnikov",
  "admin.activities.grafana.title": "Grafana",
  "admin.activities.grafana.description": "Sistemski nadzor in zdravje sistema",

  // --------------------------------------------------------------------------

  "admin.authorizations.title": "Zastopništva",
  "admin.authorizations.description": "Upravljanje z zastopništvi",

  "admin.authorizations.list.title": "Seznam zastopništev",
  "admin.authorizations.list.column.user": "Uporabnik",
  "admin.authorizations.list.column.nivoDostopa": "Nivo dostopa",
  "admin.authorizations.list.column.subject": "Subjekt",
  "admin.authorizations.list.column.validity": "Veljavnost",
  "admin.authorizations.list.column.lastUpdated": "Zadnja posodobitev",

  "admin.authorizations.list.filter.validity": "Veljavnost",
  "admin.authorizations.list.filter.user": "Uporabnik",
  "admin.authorizations.list.filter.subjekt": "Subjekt",

  "admin.authorizations.form.title.edit": "Urejanje zastopništva",
  "admin.authorizations.form.title.add": "Dodajanje zastopništva",

  "admin.authorizations.form.field.user": "Uporabnik",
  "admin.authorizations.form.field.subjekt": "Subjekt",
  "admin.authorizations.form.field.subjekt.placeholder":
    "KmgMid - Int. št. - Naziv",
  "admin.authorizations.form.field.subjekt.placeholder.small-livestock":
    "KmgMid - Int. št. ovce - Int. št. koze - Naziv",
  "admin.authorizations.form.field.from": "Datum začetka veljavnosti",
  "admin.authorizations.form.field.until": "Datum konca veljavnosti",
  "admin.authorizations.form.field.until.isEarly":
    "Datum konca veljavnosti mora biti po datumu začetka veljavnosti",

  "admin.authorizations.form.field.validityNote":
    "V primeru da je polje od/do prazno, se šteje da je zastopništvo " +
    "veljavno od trenutka dodelitve naprej oziroma do preklica.",
  "admin.authorizations.form.field.allowRights": "Dovoljenja",
  "admin.authorizations.form.field.allowCreate": "Dovoli ustvarjanje",
  "admin.authorizations.form.field.allowUpdate": "Dovoli urejanje",
  "admin.authorizations.form.field.allowDelete": "Dovoli brisanje",
  "admin.authorizations.form.field.isReadOnly": "Dovoljen samo vpogled",

  "authorization.noneAvailable":
    "Nobeno zastopništvo ni na voljo. Brez izbire zastopništva ni mogoče nadaljevati. Prosimo, kontaktirajte podporo.",
  "authorization.error":
    "Med komunikacijo s strežnikom je prišlo do napake. Preverite svojo internetno povezavo in poskusite znova. Če se težava ponavlja, kontaktirajte podporo.",
  "authorization.selectRole":
    "Izberite eno izmed zastopništev, s katerim želite nadaljevati. Spodaj so prikazana vsa zastopništva, ki so vam na voljo.",

  // --------------------------------------------------------------------------

  "admin.lookup-tables.title": "Seznam šifrantov",
  "admin.lookup-tables.description":
    "Pregled in urejanje šifrantov, ki se uporabljajo v aplikaciji",
  "admin.lookup-tables.item-disabled": "Neaktivno",

  "admin.lookup-tables.list.column.id": "Šifra",
  "admin.lookup-tables.list.column.name": "Naziv (SL)",
  "admin.lookup-tables.list.column.numericId": "Numerični ID",
  "admin.lookup-tables.list.column.originId": "Izvorni ID",
  "admin.lookup-tables.list.column.veljaZaSamce": "M",
  "admin.lookup-tables.list.column.veljaZaSamice": "Ž",

  "admin.lookup-tables.form.title.edit": "Urejanje šifranta",
  "admin.lookup-tables.form.title.add": "Dodajanje šifranta",

  "admin.lookup-tables.form.title": "Urejanje šifranta",
  "admin.lookup-tables.form.field.sifra": "Šifra",
  "admin.lookup-tables.form.field.disabled":
    "Neaktivno / onemogočeno za izbiro v vnosnih maskah",
  "admin.lookup-tables.form.field.numericId": "Numerični ID",
  "admin.lookup-tables.form.field.originId": "Izvorni ID",
  "admin.lookup-tables.form.field.veljaZaKoze": "Velja za koze",
  "admin.lookup-tables.form.field.veljaZaOvce": "Velja za ovce",
  "admin.lookup-tables.form.field.veljaZaKonje": "Velja za konje",
  "admin.lookup-tables.form.field.veljaZaGovedo": "Velja za govedo",
  "admin.lookup-tables.form.field.veljaZaPrasice": "Velja za prašiče",
  "admin.lookup-tables.form.field.veljaZaSamce": "Velja za samce",
  "admin.lookup-tables.form.field.veljaZaSamice": "Velja za samice",
  "admin.lookup-tables.form.field.naziv.sl": "Naziv (SL)",
  "admin.lookup-tables.form.field.opis.sl": "Opis (SL)",
  "admin.lookup-tables.form.field.naziv.en": "Naziv (EN)",
  "admin.lookup-tables.form.field.opis.en": "Opis (EN)",

  // --------------------------------------------------------------------------

  "admin.settings.title": "Nastavitve",
  "admin.settings.description": "Nastavitev sistema in konfiguracija",

  // --------------------------------------------------------------------------

  "admin.import.title": "Uvoz",
  "admin.import.description": "Uvoz podatkov različnih tipov iz CSV datoteke",

  // --------------------------------------------------------------------------

  "admin.templates.title": "Predloge",
  "admin.templates.description": "Upravljanje predlog",

  // --------------------------------------------------------------------------

  "admin.placeholders.title": "Ključniki",
  "admin.placeholders.description": "Upravljanje s ključniki",

  // --------------------------------------------------------------------------

  "admin.animals.title": "Živali",
  "admin.animals.description": "Začasno ročno ustvarjanje živali v admin delu",
  "admin.animals.warning.title": "Začasna implementacija",
  "admin.animals.warning.description":
    "Ta administracijski obrazec je namenjen uporabi samo med testiranjem in BO ODSTRANJEN pred produkcijo.",
  "admin.animals.form.title": "Ustvarjanje živali",
  "admin.animals.form.subtitle":
    "Vnos osnovnih podatkov za ustvarjanje nove živali prek /api/zival/data.",
  "admin.animals.form.field.species": "Vrsta živali",
  "admin.animals.form.field.gender": "Spol",
  "admin.animals.form.field.breeder": "Rejec",
  "admin.animals.form.field.owner": "Lastnik",
  "admin.animals.form.field.status": "Status",
  "admin.animals.form.field.breed": "Priznana pasma",
  "admin.animals.form.field.name": "Ime živali",
  "admin.animals.form.field.color": "Barva",
  "admin.animals.form.identifier.title": "Identifikator",
  "admin.animals.form.identifier.subtitle":
    "Izbira tipa identifikatorja je obvezna, prav tako njegova vrednost.",
  "admin.animals.form.field.identifierType": "Tip identifikatorja",
  "admin.animals.form.field.identifierValue": "Vrednost identifikatorja",
  "admin.animals.form.parents.title": "Starši",
  "admin.animals.form.parents.subtitle":
    "Po potrebi povežite že obstoječo mater ali očeta.",
  "admin.animals.form.field.mother": "Mati",
  "admin.animals.form.field.father": "Oče",
  "admin.animals.form.parentPlaceholder": "Išči po imenu ali številki",
  "admin.animals.form.additional.title": "Dodatni podatki",
  "admin.animals.form.additional.subtitle":
    "Ta polja niso obvezna, so pa na voljo za popolnejši zapis.",
  "admin.animals.form.field.originCountry": "Država izvora",
  "admin.animals.form.field.country": "Država",
  "admin.animals.form.field.originBreeder": "Izvorni rejec",
  "admin.animals.form.field.originOwner": "Izvorni lastnik",
  "admin.animals.form.field.additionalMarks": "Dodatne označbe",
  "admin.animals.form.field.imported": "Žival je iz uvoza",
  "admin.animals.form.field.notes": "Opombe",

  // --------------------------------------------------------------------------

  "admin.users.title": "Uporabniki",
  "admin.users.description": "Upravljanje uporabnikov",

  "admin.users.list.title": "Seznam uporabnikov",

  "admin.users.list.column.username": "Uporabniško ime",
  "admin.users.list.column.name": "Ime",
  "admin.users.list.column.surname": "Priimek",
  "admin.users.list.column.email": "E-mail",
  "admin.users.list.column.lastUpdated": "Zadnja posodobitev",
  "admin.users.list.column.createdOn": "Ustvarjeno",

  "admin.users.list.filter.query": "Ime, priimek, upo. ime",

  "admin.users.form.title.edit": "Urejanje uporabnika",
  "admin.users.form.title.add": "Dodajanje uporabnika",
  "admin.users.form.field.name": "Ime",
  "admin.users.form.field.surname": "Priimek",
  "admin.users.form.field.username": "Uporabniško ime",
  "admin.users.form.field.email": "E-mail",
  "admin.rk_administration.title": "Administracija rodovniških knjig",
  "admin.rk_administration.description": "Administracija rejskig knjig",
  "admin.rk_administration.addNew": "Dodaj rodovniško knjigo",
  "admin.rk_administration.table.title": "Seznam rodovniških knjig",
  "admin.rk_administration.table.naziv": "Naziv RK",
  "admin.rk_administration.form.naziv": "Naziv",
  "admin.rk_administration.table.prefix": "Predpona RK",
  "admin.rk_administration.form.prefix": "Predpona",
  "admin.rk_administration.table.rkId": "Rejski program",
  "admin.rk_administration.table.rkSifra": "Šifra RP",
  "admin.rk_administration.table.sifra": "Šifra RK",
  "admin.rk_administration.form.sifra": "Šifra",
  "admin.rk_administration.table.species": "Vrsta živali",
  "admin.rk_administration.create.success":
    "Rodovniška knjiga je bila uspešno ustvarjena",
  "admin.rk_administration.edit.success":
    "Rodovniška knjiga je bila uspešno posodobljena",

  "admin.rp_administration.title": "Administracija rejskih programov",
  "admin.rp_administration.description": "Administracija rejskih programov",
  "admin.rp_administration.table.title": "Seznam rejskih programov",
  "admin.rp_administration.addNew": "Dodaj rejski program",
  "admin.rp_administration.create.success":
    "Rejski program je bil uspešno ustvarjen",
  "admin.rp_administration.edit.success":
    "Rejski program je bil uspešno posodobljen",

  "admin.rk_rp_administration.table.actions.enable.tooltip": "Omogoči",
  "admin.rk_rp_administration.table.actions.disable.tooltip": "Onemogoči",
  "admin.rk_rp_administration.table.actions.animals.tooltip": "Pregled živali",

  "admin.rp_administration.table.primarniSpecies": "Vrsta živali",

  // --------------------------------------------------------------------------

  "basicAnswer.YES": "Da",
  "basicAnswer.NO": "Ne",

  "page.missingParam": "Manjkajoč parameter",
  "page.loading": "Nalaganje...",
  "page.pleaseWait": "Prosimo, počakajte...",
  "page.invalidAction": "Neveljavna akcija",

  "createAnimal.title": "Vnos živali",
  "createAnimal.description": "Odbira, uvoz, seme, izven kontrole",

  "notification.generic.failedToStoreData": "Napaka pri shranjevanju podatkov",
  "notification.generic.failedToStoreDataExt":
    "$t(notification.generic.failedToStoreData): {{- details}}",
  "notification.generic.failedToDeleteData": "Napaka pri brisanju podatkov",
  "notification.generic.failedToDeleteDataExt":
    "$t(notification.generic.failedToDeleteData): {{- details}}",
  "notification.generic.failedToUploadFile": "Napaka pri nalaganju datoteke",
  "notification.generic.failedToLoadData": "Napaka pri nalaganju podatkov",
  "notification.generic.failedToLoadDataExt":
    "$t(notification.generic.failedToLoadData): {{- details}}",

  "notification.generic.successfullyStoredData": "Podatki uspešno shranjeni",
  "notification.generic.successfullyDeletedData": "Podatki uspešno izbrisani",

  "notification.title.success": "Uspešno",
  "notification.title.info": "Info",
  "notification.title.fail": "Napaka",
  "notification.title.error": "Napaka",
  "notification.title.warning": "Opozorilo",
  "notification.important": "Pomembno",

  "notification.warning": "Opozorilo",
  "notification.error": "Napaka",
  "notification.createEliminationSuccess":
    "Izločitev je bila uspešno ustvarjena za naslednje živali: {{list}}",
  "notification.createEliminationError":
    "Prišlo je do napake pri izločitvi. {{id}}: {{reason}}",
  "notification.createMarkingSuccess":
    "Jagnjitev in označitev je bila uspešno ustvarjena za naslednje živali: {{list}}",
  "notification.updateMarkingSuccess":
    "Jagnjitev in označitev je bila uspešno  posodobljena za naslednje živali: {{list}}",
  "notification.createMarkingError": "Napaka pri označitvi",
  "notification.createRelocationSuccess":
    "Premik je bil uspešno ustvarjen za naslednje živali: {{list}}",
  "notification.createRelocationError":
    "Prišlo je do napake pri premiku za naslednje živali: {{list}}",
  "notification.createRelocationSuccessForAllAnimals":
    "Premik je bil uspešno ustvarjen za vse izbrane živali",
  "notification.createWeighingSliceSuccess":
    "Tehtanje je bilo uspešno ustvarjeno",
  "notification.createWeighingError": "Prišlo je do napake pri tehtanju",
  "notification.createTreatmentSuccess":
    "Tretiranje je bilo uspešno ustvarjeno",
  "notification.createTreatmentSuccessMultiple":
    "Tretiranje je bilo uspešno za naslednje živali: {{list}}",
  "notification.createTreatmentErrorWithId":
    "Prišlo je do napake pri tretiranju živali z ID: {{id}}",
  "notification.createTreatmentError":
    "Prišlo je do napake pri ustvarjanju dogodka za tretiranja",
  "notification.createQualityClassificationSuccess":
    "Določitev kakovostnega razreda je bila uspešna",
  "notification.createQualityClassificationError":
    "Prišlo je do napake pri določitvi kakovostnega razreda",
  "notification.createSeedAnalysisSuccess":
    "Analiza semena je bila uspešno ustvarjena",
  "notification.updateSeedAnalysisSuccess":
    "Analiza semena je bila uspešno posodobljena",
  "notification.createSeedAnalysisError":
    "Prišlo je do napake pri ustvarjanju analize semena",
  "notification.createLambingError":
    "Prišlo je do napake pri ustvarjanju jagnjitve",
  "notification.updateLambingError":
    "Prišlo je do napake pri posodabljanju jagnjitve",
  "notification.createWoolMeasurementSuccess":
    "Vnos za tehtanje rune je bil uspešeno ustvarjen",
  "notification.createWoolMeasurementError":
    "Prišlo je do napake pri ustvarjanju vnosa za tehtanje rune",
  "notification.createWoolAnalysisSuccess":
    "Vnos za analizo volne je bil uspešeno ustvarjen",
  "notification.createWoolAnalysisError":
    "Prišlo je do napake pri ustvarjanju vnosa za analizo volne",
  "notification.createSettlementSuccess":
    "Vnos za naselitev je bil uspešeno ustvarjen",
  "notification.createSettlementError":
    "Prišlo je do napake pri ustvarjanju vnosa za naselitev",
  "notification.createWeaningError":
    "Prišlo je do napake pri ustvarjanju odstavitve za mladiča {{ cubId }}",
  "notification.createWeaningSuccess":
    "Odstavitev je bila uspešno ustvarjena za naslednje živali: {{list}}",
  "notification.createWeaningSuccessForAllAnimals":
    "Odstavitev je bila uspešno ustvarjena za vse izbrane živali",
  "notification.downloadTemplateError":
    "Prišlo je do napake pri prenašanju predloge",
  "notification.saveTemplateSuccess": "Predloga je bila uspešno shranjena",
  "notification.saveTemplateError":
    "Prišlo je do napake pri shranjevanju predloge",
  "notification.saveAttachmentError":
    "Prišlo je do napake pri shranjevanju dokumenta za predlogo",
  "notification.savePlaceholderSuccess": "Ključnik je bil uspešno shranjen",
  "notification.savePlaceholderError":
    "Prišlo je do napake pri shranjevanju ključnika",
  "notification.deleteTemplateSuccess": "Predloga je bila uspešno izbrisana",
  "notification.deleteTemplateError":
    "Prišlo je do napake pri brisanju predloge",
  "notification.deletePlaceholderSuccess": "Ključnik je bil uspešno izbrisan",
  "notification.deletePlaceholderError":
    "Prišlo je do napake pri brisanju ključnika",
  "notification.generateDocumentError":
    "Prišlo je do napake pri generiranju dokumenta",
  "notification.fetchLambingIdForMarkingError":
    "Prišlo je do napake pri pridobivanju ID-ja kotitve",
  "notification.createFarrowSuccess": "Prasitev je bila uspešno vnešena",
  "notification.createFarrowError": "Prišlo je do napake pri vnosu za prasitev",
  "notification.uploadAttachmentError":
    "Prišlo je do napake pri nalaganju priponke",
  "notification.fetchFemaleMatingLogError":
    "Prišlo je do napake pri pridobivanju podatkov o pripustih za izbrano samico",
  "notification.fetchAnimalDetailsError":
    "Prišlo je do napake pri pridobivanju podatkov o živali",
  "notification.createAbortionSuccess": "Abortus je bil uspešno vnešen",
  "notification.createAbortionError":
    "Prišlo je do napake pri vnosu za abortus",
  "notification.deleteEliminationSuccess":
    "Izločitev je bila uspešno izbrisana",
  "notification.deleteEliminationError":
    "Prišlo je do napake pri brisanju / preklicu izločitve",
  "notification.createPurchaseSuccess": "Odkup je bil uspešno vnešen",
  "notification.fetchWeaningIdError":
    "Prišlo je do napake pri pridobivanju ID-ja odstavitve",
  "notification.createBreedingStatusError":
    "Prišlo je do napake pri ustvarjanju statusa reje rejca.",
  "notification.createBreedingStatusSuccess":
    "Status reje za izbranega rejca je bil uspešno ustvarjen.",
  "notification.createLambingSuccess": "Jagnjitev je bila uspešno ustvarjena",
  "notification.updateLambingSuccess": "Jagnjitev je bila uspešno posodobljena",
  "notification.updateSaleFormSuccess": "Prodaja je bila uspešno posodobljena",
  "notification.updateSaleFormError": "Prodajo ni bilo mogoče posodobiti",
  "notification.createSaleFormSuccess": "Prodaja je bila uspešno ustvarjena",
  "notification.confirmSaleFormError": "Prodajo ni bilo mogoče potrditi",
  "notification.confirmSaleFormSuccess": "Prodajo je bila uspešno potrjena",
  "notification.deleteSuccess": "Vnos je bil uspešno izbrisan",
  "notification.deleteError":
    "Prišlo je do napake pri brisanju / preklicu vnosa",
  "notification.createIdentifierSuccess":
    "Identifikator je bil uspešno ustvarjen",
  "notification.createIdentifierError":
    "Prišlo je do napake pri ustvarjanu identifikatorja",
  "notification.updateAnimalData":
    "Prišlo je do napake pri posodabljanju podatkov živali",

  "notification.createBrandingSuccess": "Označitev je bila uspešno vnešena",
  "notification.updateBrandingSuccess":
    "Označitev je bila uspešno posodobljena",
  "notification.createBrandingError":
    "Prišlo je do napake pri označitvi pujskov",
  "notification.exportAnimalRelatednessError":
    "Ni bilo mogoče izvoziti podatkov",
  "notification.downloadError": "Prišlo je do napake pri prenosu",

  "theme.table.checkAll": "Označi vse",
  "theme.table.uncheckAll": "Odznači vse",
  "theme.table.noData": "Ni podatkov",
  "theme.input.chooseFile": "Izberi datoteko",
  "theme.input.chooseFiles": "Izberi datoteke",
  "theme.input.noFileChosen": "Nobena datoteka ni izbrana",
  "theme.input.filesChosen": "Izbranih datotek",
  "theme.input.formatNotSupported":
    "Format datoteke ni podprt. Podprti tipi: {{formats}}.",
  "theme.input.tooManyFiles": "Max. število datotek je {{maxFiles}}.",
  "theme.table.invalidSort": "Neveljaven stolpec za razvrščanje: {{columns}}",
  "theme.table.invalidSortPlural":
    "Neveljavni stolpci za razvrščanje: {{columns}}",
  "theme.search.noData": "Ni podatkov",

  "table.chooseColumns": "Stolpci",

  "eventTable.eventName": "Naziv dogodka",
  "eventTable.rejecNaziv": "Naziv rejca",
  "eventTable.rejecSifra": "Šifra rejca",
  "eventTable.createdOn": "Ustvarjeno",

  "events.title": "Dogodki",
  "events.event": "Dogodek",
  "events.description": "Opis",
  "events.events": "Dogodki",
  "events.route.title": "Dogodki",
  "events.lambingAndMarking": "Jagnjitev in označitev",
  "events.marking": "Označitev",
  "events.mating": "Pripust",
  "events.matings": "Pripusti",
  "events.matingFemale": "Pripust samice",
  "events.matingMale": "Pripust samca",
  "events.milking": "Molža",
  "events.relocation": "Premik",
  "events.milkControl": "Kontrola mlečnosti",
  "events.selection": "Odbira",
  "events.seed": "Seme",
  "events.weaningCub": "Odstavitev mladiča",
  "events.selectionComplete": "Zaključek odbire",
  "events.weaning": "Odstavitev",
  "events.elimination": "Izločitev",
  "events.semenSaleProhibition": "Prepoved prodaje semena",
  "events.weighing": "Tehtanje",
  "events.quarantine": "V karanteni",
  "events.bloodAnalysis": "Krvna analiza",
  "events.testStation": "Na TP",
  "events.treatment": "Tretiranje",
  "events.noEventsForAnimal": "Za izbrano žival ni zabeležen noben dogodek",
  "events.physicalAssessment": "Telesne ocene",
  "events.physicalAssessmentFinal": "Končne telesne ocene",
  "events.animalIdentifier": "Identifikator živali",
  "events.purchaseTestStation": "Odkup TP",
  "events.importImport": "Uvoz uvoz",
  "events.sale": "Prodaja",
  "events.labSample": "Odvzem vzorca",
  "events.familyBookEntry": "Vpis v rodovniško knjigo",
  "events.animalTest": "Preizkus podmladka",
  "events.animalImport": "Uvoz živali",
  "events.idDocumentWithdrawal": "Odvzem identifikacijskega dokumenta",
  "events.signature": "Podpis",
  "events.wool": "Tehtanje volne",
  "events.reregistration": "Preregistracija",
  "events.identificationCheck": "Preverjanje identitete",
  "events.identificationRegistration": "Identifikacija in registracija",
  "signature.label": "Podpis",
  "signature.reviewer": "Podpis pregledovalca:",
  "signature.useStored": "Naloži shranjen podpis",
  "signature.saveAsDefault": "Shrani kot privzeti podpis",
  "signature.saveAsDefaultTooltip":
    "Shrani podpis kot privzeti podpis za trenutnega uporabnika",

  "signature.notification.success.message": "Podpis je bil uspešno shranjen",
  "signature.notification.warning.message":
    "Podpis je bil shranjen samo lokalno",
  "signature.notification.error.message":
    "Pri shranjevanju podpisa je prišlo do napake",
  "signature.default.notification.warning.message":
    "Za trenutnega uporabnika ni shranjenega podpisa",
  "signature.default.notification.error.message":
    "Pri nalagajnu privzetega podpisa je prišlo do napake. Prosimo, poskusite ponovno oz. se ponovno ročno podpišite.",

  "events.createdBy": "Izvajalec",

  "common.savedSuccessfully": "Uspešno shranjeno",

  "common.add": "Dodaj",
  "common.remove": "Odstrani",
  "common.edit": "Uredi",
  "common.delete": "Izbriši",
  "common.view": "Pregled",
  "common.search": "Išči",
  "common.back": "Nazaj",
  "common.cancel": "Prekliči",
  "common.reset": "Ponastavi",
  "event.poreklo.breed": "Pasma",
  "event.poreklo.breed.placeholder": "Izberi pasmo",

  "event.byUpload.documentsTitle": "Priloge",
  "event.byUpload.document.certificate": "Zootehniško spričevalo",

  "event.byUpload.inbreeding": "Koeficient inbreedinga ob uvozu",
  "event.byUpload.inbreeding.placeholder": "Avtomatski izračun ali ročni vnos",
  "event.byUpload.ageGroup": "Starostna skupina",

  "event.byUpload.ageGroup.placeholder": "Izberi starostno skupino",
  "event.byUpload.opomba": "Opomba",

  "event.byUpload.opomba.placeholder": "Dodatne opombe...",

  "form.edit": "Uredi",
  "form.download": "Prenesi",
  "form.delete": "Odstrani",

  animalOverview: "Pregled živali",
  newAnimal: "Nova žival",
  recentEvents: "Nedavni dogodki",
  recentEventsDescription: "Pregled zadnjih dogodkov v sistemu",

  noRecordedEvents: "Ni zabeleženih dogodkov",
  noRecordedEventsDescription: "Dogodki se bodo pokazali po vnašanju podatkov",
  allPossibleEvents: "Vsi možni dogodki",
  quickActions: "Hitre akcije",
  animalsOverview: "Pregled živali",
  documentsAndPrintouts: "Dokumenti in izpisi",
  animalId: "ID živali",
  name: "Ime",
  breed: "Pasma",
  birthDate: "Datum rojstva",
  motherId: "ID matere",
  motherLifeNumber: "ŽŠ matere",
  motherName: "Ime matere",
  fatherName: "Ime očeta",
  fatherLifeNumber: "ŽŠ očeta",
  transponderNumber: "Št. transponderja",
  pedigreeClass: "Razred RK",
  pedigree: "Rodovniška knjiga",
  pedigreeNumber: "Rodovniška številka",
  birthCountry: "Država rojstva",
  pedigreeDeterminationDate: "Datum določitve RK",
  owner: "Lastnik",
  holder: "Imetnik",
  registrationInspectionDate: "Datum pregleda registracije",
  registrationRating: "Ocena registracije",
  registrationDate: "Datum registracije",
  identificationDate: "Datum identifikacije",
  identificationRating: "Ocena identifikacije",
  rkInspectionDate: "Datum pregleda za vpis v RK",
  rkInspectionRating: "Ocena pregleda za vpis v RK",
  from: "od",
  to: "do",
  linearGradingDate: "Datum linearnega ocenjevanja",
  linearGradingGrade: "Ocena linearnega ocenjevanja",
  exhibitionGradingDate: "Datum razstavnega ocenjevanja",
  exhibitionGradingGrade: "Ocena razstavnega ocenjevanja",
  workAbilityGradingDate: "Datum PDS",
  workAbilityGradingGrade: "Ocena PDS",
  fatherId: "ID očeta",
  inbreeding: "Inbriding",
  inbreedingCoefficient: "Koeficient inbridinga",
  location: "Lokacija",
  currentLocation: "Trenutna lokacija",
  pedigreeSection: "Razdelek RK",
  notes: "Opombe",
  actions: "Akcije",
  testStation: "Testna postaja",
  genderType: "Spol/Vrsta",
  group: "Skupina",
  status: "Status",
  noTreatment: "Ni tretirana",
  hadTreatment: "Že tretirana",
  isTreated: "Tretirana",
  date: "Datum",
  qualityGrade: "Razred",
  dataSource: "Vir",
  bodyExteriorScore: "Skupna ocena",
  gain: "Prirast (g/dan)",
  operator: "Izvajalec",
  dateOfPurchase: "Datum odkupa",
  gender: "Spol",
  treatmentType: "Tip tretiranja",
  activeSubstance: "Pripravek",
  bloodAnalysisId: "Št. izvida",
  bloodAnalysisResult: "Rezultat",
  disease: "Bolezen",
  woolWeight: "Masa volne (kg)",
  withdrawalDateEnd: "Datum poteka karence",
  breeder: "Rejec",
  clearFilters: "Počisti filtre",
  temporaryId: "Začasni ID",
  originalNumber: "Originalna številka",
  noSearchResults: "Ni rezultatov iskanja",
  determined: "Določeno",
  usage: "Uporaba",
  kmgMid: "KMG-MID",
  purchaseGroup: "Odkupna skupina",
  purchaseGroupDescription: "Izbira živali v odkupni skupini na testni postaji",
  relocationDate: "Datum premika",
  genotype: "Genotip",
  domestic: "Prodaja znotraj Slovenije",
  abroad: "Prodaja v tujino",
  saleLocation: "Lokacija prodaje",
  loginDate: "Datum prejema",
  purpose: "Namen",
  earTagNumber: "Ušesna številka",
  animalsInSale: "Živali vključene v prodajo",
  saleId: "ID prodaje",
  dateOfBranding: "Datum označitve",
  sex: "Spol",
  documentId: "ID dokumenta",
  bornAsTwin: "Rojen kot dvojček",
  motherPedigreeNumber: "Rod. št. matere",
  motherTransponder: "Št. transponderja matere",

  "species.SHEEP": "Ovce",
  "species.GOAT": "Koze",
  "species.EQUINE": "Konj",
  "matingType.INDIVIDUALNI": "Individualni pripust",
  "matingType.ADMINISTRATIVNI": "Administrativni pripust",
  "matingType.HAREMSKI": "Haremski pripust",
  "matingType.OSEMENITEV": "Osemenitev",

  "filter.id": "ID živali",
  "filter.name": "Ime",
  "filter.gender": "Spol",
  "filter.breed": "Pasma",
  "filter.genotype": "Genotip",
  "filter.ageGroup": "Starostna skupina",
  "filter.birthDate": "Datum rojstva",
  "filter.status": "Status",
  "filter.motherId": "ID matere",
  "filter.fatherId": "ID očeta",
  "filter.location": "Lokacija",
  "filter.pedigreeSection": "Razdelek RK",
  "filter.notes": "Opombe",
  "filter.searchByIdOrName": "Išči po ID ali imenu živali ...",
  "filter.searchById": "Išči po ID živali",
  "filter.searchByName": "Išči po imenu živali",
  "filter.breeder": "Rejec",
  "filter.from": "Od",
  "filter.to": "Do",
  "filter.birthDateSince": "Datum rojstva od",
  "filter.birthDateUntil": "Datum rojstva do",
  "filter.breaderKmgMid": "KMG-MID rejca",
  "filter.lifeNumber": "Življenjska številka",
  "filter.breederCode": "Šifra rejca",
  "filter.breederInternalCode": "Interna številka rejca",

  "animal.zapStPripusta": "Zaporedna številka pripusta",
  "animal.species": "Vrsta živali",
  "animal.gender": "Spol",
  "animal.gender.MALE": "Moški",
  "animal.gender.FEMALE": "Ženski",
  "animal.siTagEar": "ID živali (ušesna številka)",
  "animal.genotype": "Genotip",
  "animal.earTagNumber": "Ušesna številka",
  "animal.birthNumber": "Rodovniška številka",
  "animal.noBirthNumber": "Brez rodovniške številke",
  "animal.cannotBeSeen":
    "Izbrana žival ne spada pod trenutni sklop {{sklop}} v katerem se nahajate oz. nimate ustrezni pravic za pregled podatkov izbrane živali.",
  "animal.card": "Kartica živali",
  "animal.lifeNumber": "Življenjska številka",
  "animal.lifeNumber.short": "Življenjska št.",
  "animal.color": "Barva",
  "animal.unknownBreed": "Neznana pasma",
  "animal.animalNotActive": "Žival ni aktivna",

  "animal.sex": "Spol",
  "animal.sex.MALE": "Moški",
  "animal.sex.FEMALE": "Ženski",
  "animal.sex.INTERSEKS": "Dvospolnik",
  "animal.sex.CASTRATED": "Kastrat",
  "animal.edit": "Uredi žival",
  "animal.editCancel": "Prekliči urejanje",
  "animal.dataUpdateSuccess": "Podatki o živali so bili uspešno posodobljeni",
  "animal.pedigreeUpdateSuccess":
    "Rodovniški podatki so bili uspešno posodobljeni",
  "animal.pedigreeUpdateError":
    "Prišlo je do napake pri posodabljanju rodovniških podatkov",
  "animal.dataUpdateError":
    "Prišlo je do napake pri posodabljanju podatkov o živali",
  "animal.geneologyUpdateSuccess":
    "Geneologija živali je bila uspešno posodobljena",
  "animal.geneologyUpdateError":
    "Prišlo je do napake pri posodabljanju geneologije živali",
  "animal.kopitarDataUpdateSuccess":
    "Linija, družina in rekord so bili uspešno posodobljeni",
  "animal.kopitarDataUpdateError":
    "Prišlo je do napake pri posodabljanju linije, družine in rekorda",
  "animal.originalNumberUpdateError":
    "Prišlo je do napake pri posodabljanju originalne številke živali",
  "animal.originalNumberUpdateSuccess":
    "Originalna številka je bila uspešno posodobljena",
  "animal.animalIdNumberUpdateSuccess": "ID živali je bil uspešno posodobljen",
  "animal.animalIdNumberUpdateError":
    "Prišlo je do napake pri posodabljanju ID živali",
  "animal.temporaryNumberUpdateSuccess":
    "Začasni ID živali je bil uspešno posodobljen",
  "animal.temporaryNumberUpdateError":
    "Prišlo je do napake pri posodabljanju začasnega ID živali",

  // Animal tagging / marking methods
  "markingMethod.EAR_TAG.label": "Ušesna znamka",
  "markingMethod.ELECTRONIC_EAR_TAG.label": "Elektronska ušesna označba",
  "markingMethod.MICROCHIP.label": "Mikročip",
  "markingMethod.TATTOO.label": "Tetovaža",
  "markingMethod.BOLUS.label": "Bolus",
  "markingMethod.STRAP.label": "Biceljni trak",

  "animalInBreadingProgramAnswer.YES": "Da",
  "animalInBreadingProgramAnswer.NO": "Ne",
  "eventExecutor.type.REJEC": "Rejec",
  "eventExecutor.type.UL_BF": "UL BF",
  "eventExecutor.type.UL_VF": "UL VF",
  "eventExecutor.type.KONTROLOR": "Kontrolor",
  "eventExecutor.type.SELEKCIONIST": "Selekcionist",
  "eventExecutor.type.TP": "Testna postaja",
  "eventExecutor.type.EXTERNAL_USER": "Zunanji izvajalec",
  "eventExecutor.type.ADMINISTRATOR": "Administrator",

  "ageGroup.ageGroup": "Starostna skupina",
  "ageGroup.ADULT": "Žival",
  "ageGroup.CUB": "Mladič",

  "table.selectAll": "Izberi vse",
  "table.deselectAll": "Odstrani izbor",
  "table.noData": "Ni podatkov",

  "genderAgeGroup.sheep.MALE_ADULT": "Oven",
  "genderAgeGroup.sheep.FEMALE_ADULT": "Ovca",
  "genderAgeGroup.sheep.MALE_CUB": "Jagnje",
  "genderAgeGroup.sheep.FEMALE_CUB": "Jagnje",
  "animal.speciesSifra": "Vrsta živali",
  "animal.status": "Status",
  "animal.status.ACTIVE": "Aktivna",
  "animal.status.ELIMINATED": "Izločena",
  "animal.status.INACTIVE": "Neaktivna",

  "cards.animal.title": "Podatki o živali",

  "attachments.fileUploadError": "Prišlo je do napake pri nalaganju datoteke",
  "attachments.attachToRecordError":
    "Prišlo je do napake pri povezovanju datoteke",
  "attachment.fileName": "Ime datoteke",
  "attachment.createdOn": "Ustvarjeno",
  "attachment.size": "Velikost",
  "attachment.type": "Tip",
  "attachment.file": "Datoteka",
  "attachment.upload": "Naloži",

  "form.veterinarianName": "Vnesite ime veterinarja",
  "form.notesPlaceholder": "Vnesite opombe...",
  "form.submit": "Potrdi",
  "form.error": "Napaka",
  "form.confirm": "Potrdi",
  "form.dateCannotBeInFuture": "Datum ne sme biti v prihodnosti",
  "form.actions": "Dejanja",

  "field.cannotBeInFuture": "Polje ne sme biti v prihodnosti",
  "form.dateCannotBeInPast": "Datum ne sme biti v preteklosti",
  "form.invalidDate": "Neveljaven datum",
  "form.dateIsAfterOther": "Datum mora biti enak ali po drugem datumu",
  "form.dateIsBeforeOther": "Datum mora biti enak ali pred drugim datumom",
  "form.back": "Nazaj",
  "form.uploadFileError": "Prišlo je do napake pri nalaganju datoteke",
  "form.from": "od",
  "form.to": "do",
  "form.save": "Shrani",
  "form.update": "Posodobi",
  "form.cancel": "Prekliči",
  "form.reset": "Ponastavi",
  "form.toMarking": "Naprej na označitev",
  "form.cubMarking": "Označitev mladičev",
  "form.enterDataForEachCub": "Vnesite podatke za vsakega mladiča v leglu",
  "form.cubs": "{{count}} Mladiči",
  "form.cubs_one": "{{count}} Mladič",
  "form.cubs_two": "{{count}} Mladiča",
  "form.cubs_few": "{{count}} Mladičev",
  "form.cubs_other": "{{count}} Mladičev",
  "form.combinationOfParents": "Kombinacija staršev",
  "form.important": "Pomembno",
  "form.massImport": "Masovni uvoz",
  "form.step": "Korak",
  "form.breederDetails": "Rejec in njegovi podatki",
  "form.breederDataAndCoverage": "Podatki o rejcu in pokrivanju",
  "form.breederData": "Podatki o rejcu",
  "form.breederCode": "Šifra rejca / KMG-MID",
  "card.breederCode": "Šifra rejca",
  "card.rejec.kmgMid": "KMG-MID rejca",
  "card.rejec.sifra": "Šifra rejca",
  "card.imetnik.kmgMid": "KMG-MID imetnika",
  "card.imetnik.sifra": "Šifra imetnika",
  "card.rejec.sifraRejcaSpecies": "Interna šifra rejca",
  "form.breederCodeDescription":
    "Vnesite KMG-MID in pritisnite Enter ali kliknite ikono iskanja",
  "form.breederFullName": "Ime in priimek rejca",
  "form.breederAddress": "Naslov rejca",
  "form.breederTitle": "Naziv rejca",
  "form.zipCodeAndCity": "Poštna številka in kraj",
  "form.controller": "Kontrolor",
  "form.institution": "Zavod",
  "form.phone": "Telefon",
  "form.entryOperator": "Izvajalec vnosa",
  "form.choseOperator": "Izberi izvajalca",
  "form.censusDate": "Datum popisa",
  "form.censusDateDescription": "Timestamp - lahko se nastavi",
  "form.dateAndOperator": "Datum in izvajalec vnosa",
  "form.animalType": "Vrsta živali",
  "form.motherId": "ID matere",
  "form.motherMustBeOlderThan": "Mora biti starejša ≥ {{value}} dni",
  "form.fatherId": "ID očeta",
  "form.fatherMustBeOlderThan": "Mora biti starejši ≥ {{value}} dni",
  "form.exampleId": "SI1234567",
  "form.cubExampleId": "SI1234567-1",
  "form.lambingDate": "Datum jagnjitve/jaritve",
  "form.lambing": "Jagnjitev",
  "form.lambingDateDaysBetween": "≥ {{days}} dni po prejšnji jagnjitvi",
  "form.lambingOrder": "Zaporedna jagnjitev",
  "form.lambingOrderDescription": "Pri prvi določite ročno, nato avtomatsko",
  "form.breederCodeExample": "1234567",
  "form.birthCourse": "Potek poroda",
  "form.birthCourseHint": "Izberi potek",
  "form.numberOfBornCubs": "Število rojenih mladičev",
  "form.numberOfBornCubsMax": "Največ {{value}} mladičev",
  "form.numberOfLivebornCubs": "Število živorojenih",
  "form.numberOfLivebornCubsHint": "≤ številu živorojenih",
  "form.numberOfStillBorn": "Število mrtvorojenih",
  "form.goodMother": "Dobra mati",
  "form.rating": "Ocena",
  "form.note": "Opomba",
  "form.additionalNotes": "Dodatne opombe",
  "form.documentation": "Dokumentacija",
  "form.documentationRecoredSheetVetReport":
    "Dokumentacija (evidenčni list, vet. poročilo)",
  "form.recordSheet": "Evidenčni list",
  "form.veterinaryReport": "Veterinarsko poročilo",
  "form.upload": "Naloži",
  "form.idOrTemporaryAnimalId": "Začasna ID / ID živali",
  "form.temporaryIdGeneration": "ID matere + zap št. ali SIŠ",
  "form.gender": "Spol",
  "form.select": "Izberi",
  "form.view": "Pregled",
  "form.selectOption": "Izberi",
  "form.genderType": "Spol-vrsta",
  "form.selectGenderFirst": "Izberi spol najprej",
  "form.cub": "Mladič",
  "form.color": "Barva",
  "form.breed": "Pasma",
  "form.automaticCalculation": "Avtomatski izračun",
  "form.weightAtBirth": "Teža ob rojstvu",
  "form.markType": "Način označitve",
  "form.marking.earTag": "Ušesna znamka",
  "form.marking.tattoo": "Tetovaža",
  "form.marking.electronicEarTag": "Elektronska ušesna označba",
  "form.marking.bolus": "Bolus",
  "form.marking.neckStrap": "Biceljni trak",
  "form.fate": "Usoda",
  "form.elimination": "Izločitev",
  "form.death": "Pogin",
  "form.hornStatus": "Rogatost",
  "form.maxCubs": "Največ {{max}} mladičev",
  "form.days": "dni",
  "form.additionalData": "Dodatni podatki",
  "form.additionalWeaningNotes": "Dodatne opombe o odstavitvi",
  "form.useForAllSelected": "Uporabi za vse izbrane",
  "form.medicalRecord": "zdravstveni zapisnik",
  "form.requiredField": "To polje je obvezno",
  "form.weaningDateIsRequired":
    "Datum odstavitve je obvezen za vse izbrane mladiče",
  "form.saveWeaning": "Shrani odstavitev",
  "form.weight": "Teža",
  "form.date": "Datum",
  "form.birthWeight": "Teža ob rojstvu",
  "form.age": "Starost",
  "form.atLeastOneCubMustBeSelected": "Izbran mora biti vsaj en mladič",
  "form.atLeasOneAnimalMustBeSelected": "Vsaj ena žival mora biti izbrana",
  "form.id": "ID",
  "form.temporaryId": "Začasni ID",
  "form.breeder": "Rejec",
  "form.selectedAnimals": "Izbranih {{count}} živali",
  "form.selectedAnimals_one": "Izbrana {{count}} žival",
  "form.selectedAnimals_two": "Izbrani {{count}} živali",
  "form.selectedAnimalsAndNoTreatment":
    "Izbrano živali: {{count}} (Netretirane: {{noTreatmentCount}})",
  "form.notes": "Opombe",
  "form.executor": "Izvajalec",
  "form.selectExecutor": "Izberite izvajalca",
  "form.recordingDate": "Datum beleženja",
  "form.recordingDateDescription":
    "Datum, ko je bil dogodek zabeležen na terenu",
  "form.relocationDate": "Datum premika",
  "form.newLocation": "Nova lokacija",
  "form.oldLocation": "Stara lokacija",
  "form.saveRelocation": "Shrani premik",
  "form.vehicle": "Vozilo",
  "form.backToList": "Nazaj na seznam",
  "form.zootechnicalCertificate": "Zootehniško spričevalo",
  "form.gradingPaper": "List za ocenjevanje",
  "form.export": "Izvozi",
  "form.businessRules": "Poslovna pravila",
  "form.requiredFieldsWithAsterisk": "* Označeno z zvezdico so obvezna polja",
  "form.weightKgRequired": "Teža (kg) *",
  "form.FPercentageRequired": "F (%)",
  "form.weighingLast": "Zadnje tehtanje",
  "form.weighingNumber": "Številka tehtanja",
  "form.weighingDate": "Datum tehtanja",
  "form.weighingNotes": "Dodatne opombe o tehtanju ...",
  "form.weightKg": "Teža (kg)",
  "form.selectAnimal": "Izberite žival",
  "form.weighingCount": "(Tehtanje: {{count}}/3)",
  "form.weighingLastWeight": "Zadnja teža: {{value}} kg",
  "form.treatedAt": "Datum tretiranja",
  "form.agent": "Zdravilo/preparat",
  "form.withdrawalDays": "Karenca (dni)",
  "form.operator": "Izvajalec",
  "form.treatmentNotes": "Dodatne opombe o tretiranju ...",
  "form.withdrawalUntil": "Karantena bo aktivna do:",
  "form.group": "Skupina",
  "form.saveTreatment": "Shrani tretiranje",
  "form.dateOfInspection": "Datum ocenjevanja",
  "form.dataSource": "Vir podatkov",
  "form.bodyConformationScore": "Skupna ocena telesne zgradbe",
  "form.bodyExteriorScore": "Opisna ocena zunanjosti",
  "form.gain": "Prirast (g/dan)",
  "form.qualityGrade": "Kakovostni razred",
  "form.selectorNotes": "Dodatna pojasnila selekcionista ...",
  "form.animalId": "ID živali",
  "form.backToEventList": "Nazaj na seznam dogodkov",
  "form.backToElimination": "Nazaj na izločitev",
  "form.saveAnalysis": "Shrani analizo",
  "form.saveMorphology": "Shrani morfologijo",
  "form.groupSettlement": "Množična naselitev (izberi več živali naenkrat)",
  "form.dateOfPurchase": "Datum odkupa",
  "form.settlementDate": "Datum naselitve",
  "form.bloodAnalysisNumber": "Št. izvida krvi",
  "form.bloodAnalysisDate": "Datum izvida krvi",
  "form.analysisResults": "Rezultati testov",
  "form.tbcTest": "TBC test (opcijsko)",
  "form.tctTestNumber": "Št. izvida TBC",
  "form.tctTestDate": "Datum izvida TBC",
  "form.tctTestResult": "Rezultat izvida TBC",
  "form.settlementNote": "Dodatne opombe o naselitvi ...",
  "form.animalWeightInKg": "Teža živali (kg)",
  "form.animalIDValue": "Lokacija živali ({{value}})",
  "form.animalsWithoutLocation": "Živali brez vnešene lokacije",
  "form.mandatoryFieldsMarkedWithAsterix":
    "Označeno z zvezdico so obvezna polja",
  "form.prepareProformaInvoice": "Pripravi predračun",
  "form.saveInvoice": "Shrani predračun",
  "form.pv12": "PV12 (IBM)",
  "form.seedQuality": "Kakovost semena (%)",
  "form.treatmentType": "Tip tretiranja",
  "form.name": "Ime",
  "form.birthDate": "Datum rojstva",
  "form.eliminationDate": "Datum izločitve",
  "form.eliminationReason": "Razlog izločitve",
  "form.additionalEliminationNotes": "Dodatne opombe o izločitvi",
  "form.additionalRelocationNotes": "Dodatne opombe o premiku",
  "form.testStationLogatec": "TP Testna postaja Logatec",
  "form.relocation": "Premik",
  "form.settlementNotes": "Dodatne opombe o naselitvi...",
  "form.woolWeight": "Masa volne (kg)",
  "form.analysisDate": "Datum preiskave",
  "form.micAv": "Mic_avg",
  "form.micSd": "Mic_sd",
  "form.micCv": "Mic_cv",
  "form.cem": "CEM",
  "form.pod15pr": "Pod15 %",
  "form.cfPr": "CF %",
  "form.sfMic": "SF Mic",
  "form.slMm": "SL mm",
  "form.debMin": "Deb_min",
  "form.debMax": "Deb_max",
  "form.debSd": "Deb_sd",
  "form.crv": "CRV",
  "form.crvSd": "CRV_sd",
  "form.excel": "Uvozi Excel datoteko",
  "form.saveWoolMeasurement": "Shrani analizo runa",
  "form.saveWoolWeighing": "Shrani tehtanje rune",
  "form.code": "Šifra",
  "form.animal": "Žival",
  "form.matingDate": "Datum pripusta",
  "form.identifierType": "Tip identifikatorja",
  "form.abortionDate": "Datum abortusa",
  "form.farrowingDate": "Datum prasitve",
  "form.loginDate": "Datum prejema",
  "form.famalePigsCount": "Število svinjk",
  "form.mumifiedPigsCount": "Število mumificiranih",
  "form.allPigletsWeight": "Masa gnezda (kg)",
  "form.additionalPiglets": "Število dodatnih",
  "form.removedPiglets": "Število odvzetih",
  "form.pigCondition": "Kondicija svinje",
  "form.mark": "Ocena {{count}}",
  "form.entryNumberInRegistery": "Vpisna št. v RK",
  "form.matingLog": "Pripust",
  "form.matingStation": "Pripustna postaja",
  "form.matingStationInspection": "Pregled pripustne postaje",
  "form.matingStationStallionInspection": "Pregled žrebca na pripustni postaji",
  "form.chosenPig": "Izbrana svinja",
  "form.genotype": "Genotip",
  "form.farrowingCount": "Zaporedna prasitev",
  "form.status": "Status",
  "form.saveFarrowing": "Shrani prasitev",
  "form.stable": "Hlev",
  "form.row": "Vrsta",
  "form.box": "Boks",
  "form.generateDocument": "Generiraj dokument",
  "form.downloadDocument": "Prenesi dokument",
  "form.saveMating": "Shrani pripust",
  "form.measurementDate": "Datum meritve",
  "form.backMuscleDepthCm": "Globina hrbtne mišice (cm)",
  "form.additional": "Dodatno",
  "form.malePig": "Merjasec",
  "form.femalePig": "Svinja",
  "form.matingLog.count": "Zap. št. pripusta",
  "form.validity": "Veljavnost",
  "form.valid": "Veljavna",
  "form.isValid": "Veljavno",
  "form.saveAbortion": "Shrani abortus",
  "form.createSale": "Ustvari prodajo",
  "form.saveSale": "Shrani prodajo",
  "form.confirmSale": "Potrdi prodajo",
  "form.updateSale": "Posodobi prodajo",
  "form.selectViaGroupsTP": "Izberi preko skupin (TP)",
  "form.singleAnimalSelect": "Posamezna žival",
  "form.groupSelect": "Skupinski vnos",
  "form.singleSelect": "Posamezni vnos",
  "form.bornAs": "Rojen kot",
  "form.dateOfDetermination": "Datum določitve",
  "form.breedingStatus": "Status reje",
  "form.dateOfDeterminationSince": "Datum določitve od",
  "form.dateOfDeterminationUntil": "Datum določitve do",
  "form.contractorSameAsBreeder": "Izvajalec je enak rejcu",
  "form.selectedAnimal": "Izbrana žival",
  "form.dateOfEliminationSince": "Datum izločitve od",
  "form.dateOfEliminationUntil": "Datum izločitve do",
  "form.teatsLeft": "Seski L",
  "form.teatsRight": "Seski D",
  "form.saveBranding": "Shrani označitev",
  "form.updateBranding": "Posodobi označitev",
  "form.dateFrom": "Datum od",
  "form.dateTo": "Datum do",
  "form.validDate": "Datum veljavnosti",
  "form.breedingProgram": "Rejski program",
  "form.breedingOrganisation": "Rejska organizacija",
  "form.farrowing": "Prasitev",
  "form.species": "Vrsta živali",
  "form.viewDataForOtherAnimal": "Pregled druge živali",
  "form.weightMass": "Masa",
  "form.reportType": "Vrsta poročila",
  "form.yes": "Da",
  "form.no": "Ne",
  "form.freeInput": "Prosti vnos",
  "form.savePreview": "Shrani pregled",
  "form.generateReport": "Generiraj zapisnik",
  "form.issueExpertOpinion": "Izdaj strokovno mnenje",
  "form.createNew": "Ustvari novo",
  "form.title": "Naziv",
  "form.downloadCSV": "Prenesi CSV",

  "event.dateOfBranding": "Datum označitve",
  "event.dateOfReceived": "Datum prejema",
  "form.idIsTemporary": "Začasni ID",
  "form.pregnacy": "Brejost ob prodaji",
  "form.abroadBuyer": "Rejec kupec (kamor gredo živali) - v tujini",
  "form.saleDate": "Datum prodaje",
  "form.statusSale": "Status prodaje",
  "form.entryDate": "Datum vnosa",
  "form.recievedDate": "Datum prejema",
  "form.owner": "Lastnik",
  "form.breedingCycle": "Ciklus pripusta",
  "form.basicEventData": "Osnovni podatki o dogodku",
  "form.generalData": "Osnovni podatki",
  "form.loadingEvent": "Nalaganje dogodka",
  "form.arrivalDate": "Datum prihoda",
  "form.developmentStage": "Razvojni stadij",
  "form.secondrayStaus": "Sekundarni status",
  "form.animalName": "Ime živali",
  "form.countryOfOrigin": "Država izvora",
  "form.button.next": "Naprej",
  "form.button.previous": "Nazaj",
  "form.year": "Leto",
  "form.street": "Ulica",
  "form.houseNumber": "Hišna št.",
  "form.post": "Pošta",
  "form.postNumber": "Poštna št.",
  "form.addNewAddress": "Dodaj nov naslov",

  "kmgEntity.selectKmg": "Izberi rejca",

  "weaning.route.title": "Odstavitev",
  "weaning.weaning": "Odstavitev",
  "weaning.weaningCubs": "Odstavitev mladičev",
  "weaning.separatingCubsFromMothers": "Ločitev mladičev od mater, tehtanje",
  "weaning.selectCubs": "Izbira mladičev",
  "weaning.selectCubsForWeaning":
    "Izberite mladiče za odstavitev in vnesite podatke",
  "weaning.weaningPossibleForCubsFromLambing":
    "Odstavitev je dovoljena samo za mladiče iz dogodka jagnjitve/jaritve",
  "weaning.weaningDeadline":
    "Skrajni rok za odstavitev je 9 mesecev po rojstvu",
  "weaning.dateBeforeCurrentDate":
    "Datum odstavitve mora biti ≥ datum rojstva in ≤ današnji datum",
  "weaning.weightMoreThanBirthWeight":
    "Telesna masa mora biti > 0 in > masa ob rojstvu",
  "weaning.bulkOrIndividualDateInput":
    "Možen skupinski vnos datuma ali individualno za vsakega mladiča",
  "weaning.groupDate": "Skupinski datum odstavitve (za celotno leglo)",
  "weaning.successfullyCreated": "Odstavitev je bila uspešno ustvarjena",
  "weaning.createError": "Prišlo je do napake pri ustvarjanju odstavitve",
  "weaning.weightValidation": "Teža ≥ Teža ob rojstvu",
  "weaning.selectedCubs": "Izbrani mladiči",
  "weaning.noMarkingsExistForSelectedLambing":
    "Napaka: Izbrana kotitev nima zabeleženega dogodka označitve",
  "weaning.allMarkedCubsWereWeaned":
    "Vsi označeni mladiči za izbrano kotitev so bili odstavljeni",
  "weaning.date": "Datum odstavitve",
  "weaning.weaningDateMustBeAfterLambingDate":
    "Datum označitve mora biti kasnejši kot datum jagnjitve",

  "seed.route.title": "Seme",

  "validation.prereq": "Predpogoji za vnos niso izpolnjeni",
  "validation.liveBornCubsLessThanAllCubs":
    "Št. živorojenih mora biti ≤ št. rojenih",
  "inbreeding.animal": "Žival",
  "inbreeding.animals": "Živali",
  "inbreeding.pack": "Trop",
  "inbreeding.packs": "Tropi",

  "inbreeding.firstAnimal": "Prva žival",
  "inbreeding.secondAnimal": "Druga žival",
  "inbreeding.firstPack": "Prvi trop",
  "inbreeding.secondPack": "Drugi trop",

  "inbreeding.filter.species": "Vrsta",
  "inbreeding.filter.status": "Status",
  "inbreeding.filter.gender": "Spol",
  "inbreeding.filter.stage": "Razvojni stadij",
  "inbreeding.filter.breeder": "Rejec",
  "inbreeding.filter.breed": "Pasma",
  "inbreeding.filter.owner": "Lastnik",
  "inbreeding.filter.clear": "Počisti filter",

  "inbreeding.bucket.breederPrefix": "Rejec: ",
  "inbreeding.bucket.ownerPrefix": "Lastnik: ",
  "inbreeding.bucket.breedsPrefix": "Pasme: ",
  "summary.bucket.breedsPrefix": "{{count}}Pasma: ",
  "summary.bucket.breedsPrefix_one": "Pasma: ",
  "summary.bucket.breedsPrefix_two": "Pasmi: ",
  "summary.bucket.breedsPrefix_few": "Pasme: ",

  "inbreeding.summary.species": "Vrsta",
  "summary.species": "{{count}} vrste",
  "summary.species_one": "Vrsta",
  "summary.species_two": "Vrsti",
  "summary.species_few": "{{count}} vrst",
  "summary.species_other": "Vrste",
  "inbreeding.summary.breeds": "{{count}} Pasma: ",
  "inbreeding.summary.breeds_one": "Pasma: ",
  "inbreeding.summary.breeds_two": "Pasmi: ",
  "inbreeding.summary.breeds_few": "Pasme: ",
  "inbreeding.summary.breeds_other": "Pasme: ",

  "inbreeding.summary.breeders": "Rejci",
  "inbreeding.summary.avgF": "Povp. F",

  "inbreeding.sidePanel.filter.subtitle":
    "Filtrirane živali izločijo morebitne živali iz izbire skupin, ki odpadejo zaradi filtra.",
  "inbreeding.sidePanel.noAnimals": "Ni živali za izbrane črede.",
  "inbreeding.sidePanel.noBucketsSelected": "Ni izbranih čred za izbor živali.",

  "inbreeding.sidePanel.bucketsSelected.oneSpeciesBreed":
    "Izbrano ~{{animals}} živali ({{breed}})",
  "inbreeding.sidePanel.bucketsSelected.oneSpecies":
    "Izbranih {{groups}} čred vrste {{species}} (~{{animals}} živali)",
  "inbreeding.sidePanel.bucketsSelected.mixed":
    "Izbranih {{groups}} čred (~{{animals}} živali)",

  "inbreeding.sidePanel.animalsSelected.summary": "Izbira vsebuje {{animals}}",
  "summary.breeders": "pri {{count}} rejec",
  "summary.breeders_one": "pri enem rejcu",
  "summary.breeders_two": "pri dveh rejcih",
  "summary.breeders_few": "pri {{count}} rejcih",
  "summary.breeders_other": "pri {{count}} rejcih",

  "inbreedingCalculator.title": "Izračun koeficienta inbreedinga in sorodstva",
  "inbreedingCalculator.subtitle":
    "Izračun koeficienta F (inbreeding) in R (sorodstvo) po metodi Meuwissen & Luo (1992)",
  "inbreedingCalculator.noteLabel": "Opomba:",
  "inbreedingCalculator.note":
    "Koeficient inbreedinga se samodejno izračuna ob vnosu obeh staršev v Kartici živali. To orodje omogoča dodatne primerjave med živalmi, čredami in kombinacijami.",
  "inbreedingCalculator.error": "Napaka pri izračunu",

  "inbreedingCalculator.card.title": "Izbira tipa izračuna",
  "inbreedingCalculator.card.subtitle":
    "Izberite tip primerjave za izračun koeficientov",

  "inbreedingCalculator.filters.toggle": "Filtri",
  "inbreedingCalculator.filters.title": "Filtri",
  "inbreedingCalculator.filters.clear": "Počisti",
  "inbreedingCalculator.filters.kmgMid": "KMG MID",
  "inbreedingCalculator.filters.gMid": "Lokacija (G-MID)",
  "inbreedingCalculator.filters.species": "Vrsta (ovce/koze)",

  "inbreedingCalculator.animal1Label": "Prva žival",
  "inbreedingCalculator.animal2Label": "Druga žival",
  "inbreedingCalculator.singleAnimal": "Žival",
  "inbreedingCalculator.herd": "Čreda rejca",
  "inbreedingCalculator.herdA": "Prva čreda",
  "inbreedingCalculator.herdB": "Druga čreda",
  "inbreedingCalculator.selectionSummary":
    "Izbrano je {{animalsCount}} živali iz {{breedsCount}} pasem in {{breedersCount}} rejcev.",

  "inbreedingCalculator.calculateButton": "Izračunaj koeficiente",

  "inbreedingCalculator.herdAnimalsCount": "živali",

  "inbreedingCalculator.resultCard.title": "Rezultati izračuna",
  "inbreedingCalculator.resultCard.subtitle":
    "Koeficient inbreedinga (F) in koeficient sorodstva (R)",

  "inbreedingCalculator.F.label": "Koeficient inbreedinga (F)",
  "inbreedingCalculator.F.note":
    "Prag za opozorilo je nastavljen na 6,25 % (nastavljivo v šifrantu).",
  "inbreedingCalculator.F.herdNote":
    "Pri primerjavi Čreda ↔ Čreda se koeficient F računa na ravni posameznih živali, zato je tukaj prikazan le R.",

  "inbreedingCalculator.R.label": "Koeficient sorodstva (R)",
  "inbreedingCalculator.R.note":
    "Prag za opozorilo je nastavljen na 12,5 % (nastavljivo v šifrantu).",

  "inbreedingCalculator.highF.title": "Pregled živali z visokimi koeficienti",
  "inbreedingCalculator.highF.subtitle":
    "Seznam živali, ki presegajo mejne vrednosti inbreedinga",
  "inbreedingCalculator.highF.females": "Samice z visokim F",
  "inbreedingCalculator.highF.females.none":
    "Ni podatkov - vse samice imajo F ≤ 6,25 %",
  "inbreedingCalculator.highF.males": "Samci z visokim F",
  "inbreedingCalculator.highF.males.none":
    "Ni podatkov - vsi samci imajo F ≤ 6,25 %",

  "inbreedingCalculator.section.comparison.title": "Izbira tipa izračuna",
  "inbreedingCalculator.section.comparison.subtitle":
    "Izberite tip primerjave za izračun koeficientov",

  "inbreedingCalculator.comparison.animalAnimal": "Žival ↔︎ žival",
  "inbreedingCalculator.comparison.animalPack": "Žival ↔︎ čreda",
  "inbreedingCalculator.comparison.packPack": "Čreda ↔︎ čreda",

  "inbreedingCalculator.thresholds.title": "Mejne vrednosti",
  "inbreedingCalculator.thresholds.f": "Inbreeding F:",
  "inbreedingCalculator.thresholds.r": "Sorodstvo R:",

  "inbreedingCalculator.side.left": "Leva stran",
  "inbreedingCalculator.side.right": "Desna stran",

  // Naslovi/oznake za posamezne tipe primerjav
  "inbreedingCalculator.side.left.animalAnimal": "Prva žival",
  "inbreedingCalculator.side.right.animalAnimal": "Druga žival",

  "inbreedingCalculator.side.left.animalPack": "Žival",
  "inbreedingCalculator.side.right.animalPack": "Čreda izbor",

  "inbreedingCalculator.side.left.packPack": "Prva čreda",
  "inbreedingCalculator.side.right.packPack": "Druga čreda",

  "inbreedingCalculator.select.left.animal": "Prva žival",
  "inbreedingCalculator.select.right.animal": "Druga žival",
  "inbreedingCalculator.select.left.animalFromPack": "Živali v čredi",
  "inbreedingCalculator.select.right.animalFromPack": "Živali v čredi",
  "inbreedingCalculator.select.right.bucket": "Skupine živali",
  "inbreedingCalculator.select.bucket": "Skupine živali",
  "inbreedingCalculator.select.buckets": "Črede",
  "inbreedingCalculator.select.animals": "Izbrane živali",

  "inbreedingCalculator.calculateDepth": "Globina pri izračunu",
  "inbreedingCalculator.calculate": "Izračunaj koeficiente",
  "inbreedingCalculator.calculate.loading": "Računam...",
  "inbreedingCalculator.calculate.export": "Izvozi",

  "inbreedingCalculator.section.highCoefficients.title":
    "Pregled živali z visokimi koeficienti",
  "inbreedingCalculator.section.highCoefficients.subtitle":
    "Seznam živali, ki presegajo mejne vrednosti inbreedinga",

  "inbreedingCalculator.highF.females.empty":
    "Ni podatkov - vse samice imajo F ≤ 6.25 %",
  "inbreedingCalculator.highF.males.empty":
    "Ni podatkov - vsi samci imajo F ≤ 6.25 %",

  "inbreedingCalculator.summary.left": "Leva stran",
  "inbreedingCalculator.summary.right": "Desna stran",
  "inbreedingCalculator.summary.count": "Št. živali:",
  "inbreedingCalculator.summary.missingF": "Manjka F:",
  "inbreedingCalculator.summary.fMinAvgMax": "F min/avg/max:",
  "inbreedingCalculator.summary.missingFNote":
    "Nekatere živali nimajo izračunanega F (koefInbriding).",

  "inbreedingCalculator.results.title": "Rezultati izračuna",
  "inbreedingCalculator.results.subtitle": "Matrika koeficientov sorodstva (R)",
  "inbreedingCalculator.results.notReady":
    "Rezultat še ni na voljo. Izberi živali in klikni “Izračunaj koeficiente”.",
  "inbreedingCalculator.results.leftRightHeader": "Levo \\\\ Desno",
  "inbreedingCalculator.results.fLabel": "F:",
  "inbreedingCalculator.results.missing": "manjka",
  "inbreedingCalculator.results.noData": "ni podatka",
  "inbreedingCalculator.results.thresholdHelp": "Prag opozorila:",
  "inbreedingCalculator.results.outdated":
    "Izbor živali se je spremenil. Rezultati spodaj veljajo za prejšnji izračun. Klikni “Izračunaj koeficiente”.",

  "inbreedingCalculator.results.header.animalAnimal":
    "Prva žival \\\\ Druga žival",
  "inbreedingCalculator.results.header.animalPack":
    "Prva žival \\\\ Druga čreda",
  "inbreedingCalculator.results.header.packPack": "Prva čreda \\\\ Druga čreda",

  "inbreedingCalculator.validation.selectBothSides":
    "Izberi podatke na obeh straneh.",
  "inbreedingCalculator.validation.animalAnimal":
    "Žival ↔︎ žival: izberi točno 1 žival na vsaki strani.",
  "inbreedingCalculator.validation.leftOneAnimal": "Levo izberi 1 žival.",
  "inbreedingCalculator.validation.rightAtLeastOne":
    "Desno izberi vsaj 1 žival.",
  "inbreedingCalculator.validation.packPack":
    "Čreda ↔︎ čreda: izberi vsaj 1 žival na obeh straneh.",

  "marking.important.temporaryId":
    "Začasna ID se generira avtomatsko: ID matere + zap. št. mladiča",
  "marking.important.officialId":
    "Uradna ID se vnese najkasneje do 9. meseca starosti",
  "marking.important.status":
    'Status rojenim mladičem se avtomatsko nastavi na "Aktivna"',
  "marking.important.breed": "Pasma se izračuna avtomatsko na osnovi staršev",
  "marking.important.genderType":
    "Spol-vrsta se samodejno nastavi glede na izbran spol",

  "animal.singleAnimal": "Žival",
  "animal.identifierLabel": "Identifikator",
  "animal.route.title": "Podatki o živali",
  "animal.basicData": "Osnovni podatki",
  "animal.pedigree": "Rodovnik",
  "animal.field": "Polje",
  "animal.events": "Dogodki",
  "animal.breedingValues": "Plemenske vrednosti",
  "animal.breedingValuesStandardized":
    "Napovedi plemenskih vrednosti po lastnostih (standardizirano, povprečje 100, SD 12)",
  "animal.qualityClassification": "Kakovostni razred",
  "animal.qualityClassificationByGrades":
    "Razvrstitev živali po kakovosti in ocenah (2A = najboljši, 3B = najslabši)",
  "animal.noQualityClassification":
    "Žival nima zabeleženega kakovostnega razreda",
  "animal.currentQualiyClassification": "Trenutni kakovostni razred",
  "animal.qualityClassificationUsage":
    "Zadnji veljavni kakovostni razred se uporablja pri generiranju zootehniškega spričevala.",
  "animal.qualityClassification.from": "Od {{value}}",
  "animal.growthPerDay": "g/dan",
  "animal.exteriorDescription": "Opisna ocena zunanjosti",
  "animal.dataSource": "Vir podatkov",
  "animal.documents": "Dokumenti",
  "animal.documentsAndAttachments": "Dokumenti in priloge",
  "animal.savedDocumentation":
    "Shranjeni dokumenti, potrdila, izvidi in ostala dokumentacija",
  "animal.bloodAnalysisRecords": "Krvne analize",
  "animal.animalCard": "Kartica živali",
  "animal.historicalInsight": "Zgodovinski vpogled",
  "animal.animal": "Žival",
  "animal.animalId": "ID živali",
  "animal.temporaryId": "Začasni ID",
  "animal.originalNumber": "Originalna številka",
  "animal.name": "Ime",
  "animal.overallBodyScore": "Skupna ocena telesne zgradbe",
  "animal.growth": "Prirast",
  "animal.animalNotInPedigreeBook": "Žival ni vpisana v rodovniško knjigo",

  "animal.birthDate": "Datum rojstva",
  "animal.weaningDate": "Datum odstavitve",
  "animal.breed": "Pasma",

  "animal.breeder": "Rejec",
  "animal.location": "Lokacija",
  "animal.identification": "Identifikacija",
  "animal.locationAndBreeder": "Lokacija in rejec",
  "animal.geneticData": "Genetski podatki",
  "animal.inbreedingCoefficient": "Koef. inbridinga",
  "animal.breedProportions": "Deleži pasem",
  "animal.pedigreeBook": "Rodovniška knjiga",
  "animal.entryNumber": "Številka vpisa",
  "animal.entryDate": "Datum vpisa",
  "animal.fatherId": "ID očeta",
  "animal.motherId": "ID matere",
  "animal.grandparentsFather": "Stari starši (oče)",
  "animal.grandParentsMother": "Stari starši (mati)",
  "animal.section": "Razdelek",
  "animal.pedigreeBookFourGenerations":
    "Podrobno poreklo in predniki živali s popolnim rodovnikom do 4. generacije",
  "animal.lifeEvents": "Življenjski dogodki",
  "animal.lifeEventsOverview":
    "Kronološki pregled vseh dogodkov skozi življenjski cikel živali",
  "animal.operator": "Izvajalec",
  "animal.ancestors": "Predniki",
  "animal.father": "Oče",
  "animal.unknownFather": "Oče ni znan",
  "animal.mother": "Mati",
  "animal.unknownMother": "Mati ni znana",
  "animal.noBreedingValues": "Žival nima zabeležene nobene plemenske vrednosti",
  "animal.zadnjaZaporednaStevKotitve": "Zaporedna številka prasitve",
  "animal.ageGroup": "Starostna skupina",
  "animal.owner": "Lastnik",
  "animal.animalHasNoBreeder": "Žival ni vezana na nobenega rejca",
  "animal.fatherEarTagNumber": "Oče ušesna številka",
  "animal.motherEarTagNumber": "Mati ušesna številka",
  "animal.geneticAnalysisPerformed": "Izvedena genska analiza",
  "animal.uploadDocument": "Naloži dokument",
  "animal.fatherAnalysisUpdateError":
    "Napaka pri posodabljanju genske analize očeta",
  "animal.pedigreeBookDepth": "Prikazano število generacij",

  "animal.colouration": "Obarvanost",
  "animal.additionalTag": "Dodatna oznaka",
  "animal.fatherInfo": "Podatki o očetu",
  "animal.motherInfo": "Podatki o materi",

  "animalGender.MALE": "Samec",
  "animalGender.FEMALE": "Samica",
  "animalGender.INTERSEX": "Interseks",
  "animalGender.CASTRATED": "Kastriran",

  "pedigree.mainSection": "Glavni del",

  "breedingValue.accuracy": "Točnost",
  "breedingValue.rank": "Rang",
  "breedingValue.trend": "Trend",
  "breedingValue.milkiness": "Mlečnost",
  "breedingValue.growth": "Prirast",
  "breedingValue.fatContent": "Vsebnost maščobe",
  "breedingValue.proteinContent": "Vsebnost beljakovin",
  "breedingValue.fertility": "Plodnost",
  "breedingValue.offspringGrowth": "Prirast mladičev",
  "breedingValue.maternalTraits": "Materinske lastnosti",
  "breedingValue.dateCalculated": "Datum izračuna",
  breedingValues: "Plemenske vrednosti",
  "breedingValues.description": "Pregled nad plemenskimi vrednostmi",
  "breedingValues.selectOption": "Izberite želeni vpogled oziroma akcijo",
  "breedingValues.catalog": "Katalog PV",
  "breedingValues.catalog.description":
    "Pregled in iskanje po katalogu plemenskih vrednosti",
  "breedingValues.rank": "Rang PV",
  "breedingValues.rank.description":
    "Razvrstitev živali po posameznih lastnostih",
  "breedingValues.comparisonRank": "Primerjalni rang PV",
  "breedingValues.comparisonRank.description":
    "Prikaz ranga živali glede na eno izbrano lastnost",
  "breedingValues.comparisonGeneticTrend": "Primerjalni genetski trend PV",
  "breedingValues.comparisonGeneticTrend.description":
    "Grafični prikaz gibanja [povprečja] plemenskih vrednosti skozi čas za izbrano lastnost",
  "breedingValues.dataDownload": "Prenos podatkov",
  "breedingValues.dataDownload.description":
    "Izvoz podatkov plemenskih vrednosti po izboru kataloga, populacije in obdobja",
  "breedingValues.populationCode": "Populacija izračuna (KODPOP)",
  "breedingValues.billingMethod": "Metoda izračuna",
  "breedingValues.type": "Tip PV",
  "breedingValues.calculation": "Koda izračuna (KODOBR)",
  "breedingValues.drawCatalog": "Nariši katalog",
  "breedingValues.catalogVersion": "Koda izračuna (KODOBR)",
  "breedingValues.selectOrDeselectAll": "Označi/odznači vse",
  "breedingValues.limitOutput": "Omejitev izpisa",
  "breedingValues.officiality": "Uradnost",
  "breedingValues.parameters": "Parametri",
  "breedingValues.trend": "Trend",
  "breedingValues.birthFrom": "Rojstvo živali od",
  "breedingValues.birthTo": "Rojstvo živali do",
  "breedingValues.to": "Do",
  "breedingValues.minPv12": "PV12 min",
  "breedingValues.idOrPedigree": "IdZiv/Rodovna",
  "breedingValues.property": "Lastnost (KODPV)",
  "breedingValues.selectParameters": "Izbira parametrov",
  "breedingValues.yearFrom": "Leto od",
  "breedingValues.yearTo": "Leto do",
  "breedingValues.performComparison": "Izvedi primerjavo",
  "breedingValues.numberOfDisplayed": "Število prikazanih",
  "breedingValues.calculationComparison": "Izračun (KODOBR) za primerjavo",
  "breedingValues.breedingValueCodes": "Lastnosti (KODPV)",
  "breedingValues.animalId": "ID živali",
  "breedingValues.breedingValueCriteria": "Lastnost kriterij",
  "breedingValues.displayType": "Tip prikaza",
  "breedingValues.download": "Prenesi",
  "breedingValues.noData": "Ni podatkov",
  "breedingValues.forCattle": "Plemenske vrednosti za govedo",
  "breedingValues.location": "Lokacija",
  "breedingValues.uploadCSV": "Naloži CSV",
  "breedingValues.downloadCSV": "Naloži CSV template",
  "breedingValues.uploadCSV.success": "Nalaganje CSV datoteke je bilo uspešno.",
  "breedingValues.uploadCSV.error":
    "Prišlo je do napake pri nalaganju CSV datoteke.",
  "breedingValues.animalNotFoundWithIdentifier":
    "Žival z identifikatorjem {{identifier}} ni bila najdena v IS POKK",
  "breedingValues.errorFetchingAnimalData":
    "Prišlo je do napake pri pridobivanju podatkov o živali",
  "breedingValues.showPedigree": "Prikaži rodovnik",

  "breedingValues.columns.code": "KodPV",
  "breedingValues.columns.property": "Lastnost",
  "breedingValues.columns.unit": "Enota",
  "breedingValues.columns.population": "Pop",
  "breedingValues.columns.calculationMethod": "Sel",
  "breedingValues.columns.breedingValueType": "TipPV",
  "breedingValues.columns.calculationCode": "Izr",
  "breedingValues.columns.numberOfUnits": "N",
  "breedingValues.columns.edc": "Edc",
  "breedingValues.columns.averageUsedData": "Pov",
  "breedingValues.columns.accuracy": "R%",
  "breedingValues.columns.absoluteValue": "Pv",
  "breedingValues.columns.standardizedValue": "Pv12",
  "breedingValues.columns.valueOfficiality": "Uradnost",
  "breedingValues.columns.absoluteRang": "Rang",
  "breedingValues.columns.rangPercent": "%Rang",
  "breedingValues.columns.trend": "Trend",
  "breedingValues.columns.newRank": "Novi",
  "breedingValues.columns.oldRank": "Stari",
  "breedingValues.columns.pedigreeNum": "Rod. št.",
  "breedingValues.columns.breed": "Pasma",
  "breedingValues.columns.id": "ID",
  "breedingValues.columns.name": "Ime",
  "breedingValues.columns.birthDate": "Dat. roj.",
  "breedingValues.columns.officiality": "Uradnost",
  "breedingValues.columns.status": "Status",
  "breedingValues.columns.snp": "SNP",
  "breedingValues.columns.locationId": "Lokacija",
  "breedingValues.columns.graph": "Graf",
  "breedingValues.columns.location": "Lokacija",

  "breedingValues.savedPresets": "Shranjene nastavitve",
  "breedingValues.savedPresets.setNameForPreset":
    "Nastavi ime za shranjene nastavitve",
  "breedingValues.savedPresets.presets": "Nastavitve",
  "breedingValues.savedPresets.name": "Ime",

  "breedingValues.birthYear": "Leto rojstva",
  "breedingValues.fatherBirthYear": "Leto rojstva očeta",
  "breedingValues.averageDescendants": "Povprečno število potomcev",
  "breedingValues.numberOfAnimals": "Št. živali",
  "breedingValues.numberOfAnimalsPerBirthYear":
    "Število živali glede na leto rojstva",
  "breedingValues.trendPv12": "Trend PV12",
  "breedingValues.trendPvPoLetihRojstva.title": "Trend PV",
  "breedingValues.steviloZivaliPoLetihRojstva.title":
    "Število živali po letih rojstva",
  "breedingValues.steviloPotomcevGledeNaRojstvaOcetov.title":
    "Povprečno število {{childLabel}} glede na leto rojstva {{fatherLabel}}",
  "breedingValues.calculationMethods": "Metoda izračuna",
  "breeding.values.animalNotFound":
    "Za izbrano žival ni evidentiranih plemenskih vrednosti",
  "breedingValues.odstopanjePovprecjaMladicevGledeNaOceta.title":
    "Odstopanje povprečja {{childLabel}} od očeta",
  "breedingValues.deviation": "Odstopanje",
  "breedingValues.descendantDeviation": "Odstopanje povprečne PV potomcev",
  "breedingValues.pvClass": "Razred PV",
  "breedingValues.fatherPvClass": "Razred PV očeta",
  "breedingValues.steviloZivaliPoVrednostiRazredaPv.title":
    "Število živali po vrednosti razreda PV",
  "breedingValues.upToResults":
    "Prenese se lahko največ {{value}} zapisov naenkrat.",
  "breedingValues.loadingPlemenskaZival": "Nalaganje živali",
  "breedingValues.errorFetching":
    "Prišlo je do napake pri nalaganju plemenskih vrednosti",
  "breedingValues.elimination": "Izločitev",
  "breedingValues.section": "Sklop",
  "breedingValues.selectedAnimal": "Izbrana žival",
  "breedingValues.animalRang": "Rang živali",
  "breedingValues.locationKmgMid": "Lokacija",

  "documents.documents": "Dokumenti",
  "documents.officiallyConfirmedDocuments":
    "Uradno potrjeni in pooblaščeni dokumenti",
  "documents.zootechnicalCertificate.title": "Zootehniško spričevalo",
  "documents.zootechnicalCertificate.description":
    "Uraden dokument za plemenske živali",
  "documents.activeBreedersLetter.title":
    "Dopis aktivni rejci / aktivne živali",
  "documents.activeBreedersLetter.description":
    "Poročilo o aktivnih rejcih in živalih",
  "documents.sheepGoatBreedingCertificate.title": "Potrdilo o vključitvi v RP",
  "documents.sheepGoatBreedingCertificate.description":
    "Uradno potrdilo za rejce",
  "documents.fertilityLetter.title": "Plodnost - dopis",
  "documents.fertilityLetter.description": "Dopis s podatki o plodnosti",
  "documents.milkProductionLetter.title": "Mlečnost - dopis",
  "documents.milkProductionLetter.description": "Dopis s podatki o mlečnosti",
  "document.generateDocument": "Generiranje dokumenta",
  "document.documentPlaceholders": "Ključniki v dokumentu",
  "documents.pigs.definedInAnalitics": "Manjkajoči izpisi",
  "documents.pigs.definedInAnalitics.description":
    "Ostali izpisi se nahajajo v zavihku analitika",

  "reports.herdbook.title": "Rodovniška knjiga",
  "reports.herdbook.description": "Evidenca rodovniških živali",
  "reports.breederAnimalsList.title": "Seznam živali za rejca",
  "reports.breederAnimalsList.description": "Pregled vseh živali po rejcih",
  "reports.controlBreedersInPeriod.title": "Seznam aktivnih rejcev",
  "reports.controlBreedersInPeriod.description":
    "Seznam aktivnih rejcev v izbranem obdobju",
  "reports.fertilityByBreedingAnimals.title":
    "3.2 - Plodnost po živalih pri rejcih",
  "reports.fertilityByBreedingAnimals.description":
    "Podatki plodnosti po živalih",
  "reports.fertilityByBreeders.title": "3.5 - Plodnost po rejcih",
  "reports.fertilityByBreeders.description": "Skupna plodnost po rejcih",
  "reports.milkYieldAverageSlovenia.title": "4.4 - Mlečnost-povp_slo",
  "reports.milkYieldAverageSlovenia.description": "Povprečje za Slovenijo",
  "reports.milkControl.title": "4.7.1 - Kontrola mlečnosti",
  "reports.milkControl.description": "Pregled kontrol mlečnosti",
  "reports.missingControlsOverview.title": "4.8 - Pregled nevenesnih kontrol",
  "reports.missingControlsOverview.description": "Manjkajoče kontrole",
  "reports.youngAnimalsGrowthInHerd.title":
    "4.11 - Seznam mladičev v tropu_prirast-interna oznaka",
  "reports.youngAnimalsGrowthInHerd.description": "Prirast mladičev v tropu",
  "reports.animalOriginData.title": "5.1 - Podatki o poreklu živali",
  "reports.animalOriginData.description": "Podrobno poreklo",
  "reports.breedingAnimalsWithoutScores.title":
    "6.1 - Plemenjaki z brez telesnih ocen",
  "reports.breedingAnimalsWithoutScores.description":
    "Pregled ocen plemenjakov",
  "reports.koeficientSorodstva.title": "6.3.2 - Koeficient sorodstva",
  "reports.koeficientSorodstva.description":
    "Koeficient sorodstva (žival - žival)",
  "reports.kinshipCoefficient.title": "6.4 - Izračun sorodstva",
  "reports.kinshipCoefficient.description": "Koeficient sorodstva",
  "reports.matingLog.title": "Dnevnik pripustov",
  "reports.matingLog.description": "Pregled in izpis dnevnikov pripustov",
  "reports.webActiveAnimals.title": "1.2 - web_aktivne živali",
  "reports.webActiveAnimals.description": "Spletni prikaz aktivnih živali",
  "reports.controlStockOnDay.title": "1.7 - kontr_Stalež na dan",
  "reports.controlStockOnDay.description": "Kontrola staleža na izbrani dan",
  "reports.fertilityByYearsBreeder.title":
    "3.3 - por_plodnost po letih pri rejcu",
  "reports.fertilityByYearsBreeder.description": "Poročilo plodnosti po letih",
  "reports.lactationCalculation.title":
    "4.2, 4.3 Mlečnost delni in končni izračuni",
  "reports.lactationCalculation.description":
    "Izračuni delnih in končnih laktacijskih izračunov",
  "reports.standardizedLactationReport.title":
    "4.5 - por_lakt_zak_STD_laktacija",
  "reports.standardizedLactationReport.description":
    "Standardizirana laktacija",
  "reports.controlsByBreeding.title": "4.7.2 - Kontrole pri rejcih",
  "reports.controlsByBreeding.description": "Kontrole po rejcih",
  "reports.weighingYoungInternalMark.title":
    "4.9 - Seznam mladičev tehtanja_interna oznaka",
  "reports.weighingYoungInternalMark.description": "Tehtanja z interno oznako",
  "reports.growthControlByBreeds.title": "4.12 - kontr_Prirast-po pasmah",
  "reports.growthControlByBreeds.description": "Kontrola prirasta po pasmah",
  "reports.youngAnimalOriginData.title": "5.2 - Podatki o poreklu mladič",
  "reports.youngAnimalOriginData.description": "Poreklo mladičev",
  "reports.exhibitedAnimalsControl.title": "7.1 - kontr_Izložene živali",
  "reports.exhibitedAnimalsControl.description": "Seznam izloženih živali",
  "reports.pedigree.title": "Poreklo oz. rodovnik",
  "reports.pedigree.description": "Izpis rodovniškega drevesa",
  "reports.herdData.title": "1.4 - trop_podatki o živalih",
  "reports.herdData.description": "Podrobni podatki o tropih",
  "reports.animalsEvaluationControl.title": "2.1 - kontr_Ocenjevanje živali",
  "reports.animalsEvaluationControl.description": "Kontrola in ocenjevanje",
  "reports.herdFertilityGrowthYoung.title":
    "3.4 - trop_plodnost_prirast mladičev",
  "reports.herdFertilityGrowthYoung.description":
    "Plodnost in prirast po tropih",
  "reports.completedLactationReport.title": "4.3 - por_lakt_zak_cela_laktacija",
  "reports.completedLactationReport.description": "Zaključena cela laktacija",
  "reports.milkYieldAverageSloveniaStandardized.title":
    "4.6 - Mlečnost-povp_slo_std_lakt",
  "reports.milkYieldAverageSloveniaStandardized.description":
    "Povprečje SLO - standardizirana",
  "reports.weighingAtWeaningInternalMark.title":
    "4.10 - Tehtanja ob odstavitvi-interna oznaka",
  "reports.weighingAtWeaningInternalMark.description": "Teža pri odstavitvi",
  "reports.growthControlByInstitutions.title":
    "4.13 - kontr_Prirast-po zavodih",
  "reports.growthControlByInstitutions.description":
    "Kontrola prirasta po zavodih",
  "reports.animalOriginOverview.title": "5.3 - Poreklo živali",
  "reports.animalOriginOverview.description": "Splošno poreklo",
  "reports.averageKinshipWithHerd.title": "6.3 - Povprečno sorodstvo s tropom",
  "reports.averageKinshipWithHerd.description": "Analiza sorodstva",
  "reports.herdBreedingValuesActiveAnimals.title":
    "8.1 - Trop_PV_aktivne živali",
  "reports.herdBreedingValuesActiveAnimals.description":
    "Plemenske vrednosti tropa",
  "reports.dopolnitevRodovnika.title": "5.4 - Dopolnitev rodovnika",
  "reports.dopolnitevRodovnika.description": "Dopolnitev rodovnika",
  "reports.stalezVObdobjuPriRejcu.title": "1.7.1 Stalež v obdobju pri rejcu",
  "reports.stalezVObdobjuPriRejcu.description": "Stalež v obdobju pri rejcu",
  "reports.stalezVRodovniskiKnjigi.title":
    "1.7.2 Stalež v rodovniški knjigi na dan",
  "reports.stalezVRodovniskiKnjigi.description":
    "Stalež v rodovniški knjigi na dan",
  "reports.seznamRejcevRK.title": "1.7.3 Seznam rejcev v rodovniški knjigi",
  "reports.seznamRejcevRK.description":
    "Seznam rejcev v rodovniki knjigi v obdobju s staležem",

  "templates.route.title": "Predloge",
  "templates.selectDocument": "Izberi DOCX predlogo",
  "templates.subtitle": "Upravljanje s predlogami",
  "templates.placeholders.subTitle": "Upravljanje s ključniki",
  "templates.placeholderList": "Seznam ključnikov",
  "templates.templateList": "Seznam predlog",
  "templates.createNew": "Nova predloga",
  "templates.create": "Ustvari predlogo",
  "templates.save": "Shrani predlogo",
  "templates.edit": "Uredi predlogo",
  "templates.templates": "Predloge",
  "templates.group": "Skupina",
  "templates.key": "Ključ",
  "templates.path": "Pot",
  "templates.name": "Ime",
  "templates.language": "Jezik",
  "templates.validFrom": "Veljavnost od",
  "templates.validTo": "Veljavnost do",
  "templates.comment": "Komentar",
  "templates.placeholders": "Ključniki",
  "templates.type": "Tip",
  "templates.value": "Vrednost",
  "templates.createPlaceholder": "Ustvari ključnik",
  "templates.savePlaceholder": "Shrani ključnik",
  "templates.editPlaceholder": "Uredi ključnik",
  "templates.deletePlaceholderError":
    "Prišlo je do napake pri brisanju ključnika",
  "templates.editTemplate": "Uredi predlogo",
  "templates.placeholders.route.title": "Ključniki",
  "templates.placeholder": "Ključnik",
  "templates.code": "Šifra",
  "templates.note": "Opomba",
  "templates.placeholder.const": "CONST - Konstanta",
  "templates.placeholder.ptext": "PTEXT - Programsko izračunljivo polje",
  "templates.placeholder.pbox":
    "PBOX - Programsko izračunljivo kompleksno polje",
  "templates.placeholder.short":
    "SHORT - Kratko vnosno polje (vnos ob kreiranju dokumenta)",
  "templates.placeholder.long":
    "LONG - Dolgo vnosno polje (vnos ob kreiranju dokumenta)",
  "templates.placeholder.table": "TABLE - Programsko izračunljiva tabela",
  "templates.placeholder.context":
    "CONTEXT - Poznano iz konteksta na strani UI",
  "templates.placeholder.column": "COLUMN - Programsko izračunljiv stolpec",
  "templates.delete": "Izbriši",
  "templates.noPlaceholdersForTemplate": "Predloga nima dodatnih polj",
  "templates.search": "Iskanje",
  "templates.fileName": "Ime datoteke",
  "templates.fileNotFound": "Datoteka ni bila najdena",

  "printouts.printouts": "Izpisi",
  "printouts.detailedPrintouts": "Podrobni izpisi in poročila za analizo",

  // BEGIN REPORTS
  "reports.routes.title": "Poročila",
  "reports.routes.createNew": "Novo poročilo",
  "reports.list": "Seznam poročil",
  "reports.list.subTitle": "Pregled in upravljanje predlog poročil",
  "reports.newReport": "Novo poročilo",
  "reports.newReport.description":
    "Uvoz nove predloge poročila narejene z Jasper Studio",
  "reports.editReport": "Urejanje poročila",
  "reports.editReport.description":
    "Urejanje predloge poročila narejene z Jasper Studio",
  "reports.type": "Tip",
  "reports.name": "Naziv poročila",
  "reports.name.placeholder": "Naziv poročila",
  "reports.file": "Datoteka",
  "reports.file.placeholder": "Naložite Jasper ({{ extensions }}) datoteko",
  "reports.file.helpText":
    "če so v poročilu binarni elementi (slike...) naložite .jasper datoteko",
  "reports.group": "Skupina",
  "reports.species": "Sklop",
  "reports.species.relevantFor": "Relevantno za sklop",
  "reports.species.helpText":
    "Glede na označitev se poročilo prikaže v zavihku analitika pri posameznem sklopu",
  "reports.species.small-livestock": "Drobnica",
  "reports.species.pigs": "Prašiči",
  "reports.species.horses": "Kopitarji",
  "reports.group.placeholder": "Opcijsko vnesite skupino poročila",
  "reports.group.helpText":
    "Skupina poročila za grupiranje poročil ter lažje iskanje",
  "reports.type.placeholder": "Tip izvoza poročila",
  "reports.type.searchPlaceholder": "Izberite tip poročila",
  "reports.filename": "Ime datoteke",
  "reports.updatedOn": "Zadnja sprememba",
  "reports.createdOn": "Datum nastanka",
  "reports.createdOn.from": "Datum nastanka od",
  "reports.createdOn.to": "do",

  "reports.createNew": "Dodaj",
  "reports.save": "Shrani",
  "reports.edit": "Urejanje poročila",
  "reports.delete": "Izbriši poročilo",
  "reports.delete.confirmationText":
    'Ali ste prepričani da želite izbrisati poročilo "{{ templateName }}"?',

  "reports.parameters": "Parametri poročila",
  "reports.parametersAdd": "Dodaj parameter",
  "reports.deleteParameter": "Izbriši parameter",
  "reports.parameterName": "Ime parametra",
  "reports.parameterType": "Tip parametra",
  "reports.nullable": "Obvezno",
  "reports.nullable.yes": "Da",
  "reports.nullable.no": "Ne",
  "reports.type.string": "Tekst (String)",
  "reports.type.number": "Število (Integer)",
  "reports.type.date": "Datum",
  "reports.type.uuid": "UUID",
  "reports.type.extended.small-livestock.uuid": "Izbira živali",
  "reports.defaultValue": "Privzeta vrednost",
  "reports.defaultValue.helpText":
    "Predizpolnjena vrednost pri generiranju poročila",
  "reports.description": "Opis",
  "reports.description.placeholder": "Kratek opis parametra",
  "reports.description.helpText":
    "Opis se prikaže pri dialogu za generiranje poročila",
  "reports.generate": "Generiraj",
  "reports.generateReport": "Generiraj poročilo",
  "reports.noParameters": "Za to poročilo ni dodatnih parametrov.",
  "reports.noReports": "Ni poročil.",
  "reports.generateError":
    "Prišlo je do napake pri generiranju poročila!\n {{error}}",

  // END REPORTS

  "analytics.analytics": "Analitika",
  "analytics.analyticsAndReports": "Analitika in poročila",
  "analytics.detailedStatistics": "Podrobne statistike in analize za drobnico",
  "analytics.herdStructure": "Struktura čred in tropov",
  "analytics.breedingScope": "Rejski obseg",
  "analytics.fertility": "Plodnost",
  "analytics.cubsPerLambing": "Mladičev na jagnjitev",
  "analytics.fertilityAverage": "Povprečje na leglo",
  "analytics.perLactation": "Na laktacijo",
  "analytics.milkiness": "Mlečnost",
  "analytics.milkinessAverageQuantity": "Povprečna količina",
  "analytics.activeAnimals": "Aktivnih živali",

  "matingLog.title": "Dnevnik pripustov",
  "matingLog.description": "Evidenca paritev (naravni/umetni pripust)",
  "matingLog.matingLogDoesntExistForFemale":
    "Za izbrano samico trenutno še ni pripusta. Če želite nadaljevati, bo ustvarjen administrativni pripust za to samico.",
  "matingLog.matingLogExists":
    "Pripust za izbrano mater je zabeležen v sistemu (Datum zač. pripusta: {{date}})",
  "matingLog.createMatingLogFirst":
    "Najprej je potrebno ustvariti nov pripust.",

  "weaning.title": "Odstavitev mladičev",
  "weaning.description": "Ločitev mladičev od mater, tehtanje",

  "milkiness.title": "Mlečnost",
  "milkiness.description": "Kontrola mlečnosti - količina in kakovost",

  "milking.title": "Molža",
  "milking.description": "Začetek in konec molžnega obdobja",

  "elimination.title": "Izločitev",
  "elimination.description": "Izločitev živali iz reje",
  "elimination.selectAnimalsForElimination": "Izbira živali za izločitev",
  "elimination.selectAnimalsForEliminationFromHusbandry":
    "Izberite živali, ki jih želite izločiti iz reje",
  "elimination.additionalData": "Dodatni podatki",
  "elimination.reasonAndWeight": "Podatki o vzroku in teži ob izločitvi",
  "elimination.reason": "Vzrok izločitve",
  "elimination.selectReason": "Izberi vzrok",
  "elimination.weight": "Teža ob izločitvi",
  "elimination.weightDescription": "Teža živali ob izločitvi v kilogramih",
  "elimination.additionalNotes": "Dodatne opombe o izločitvi",
  "elimination.additionalNotesDescription":
    "Prostor za dodatne informacije o razlogu izločitve",
  "elimination.eliminateAnimals": "Izloči živali",

  "elimination.reason.nothing": "Nič",
  "elimination.reason.disease": "Bolezen",
  "elimination.reason.injury": "Poškodba",
  "elimination.reason.death": "Pogin",
  "elimination.reason.pedigreeError": "Napaka v rodovniku",
  "elimination.reason.breederDecision": "Odločitev rejca",
  "elimination.reason.slaughter": "Zakol",
  "elimination.reason.emergencySlaughter": "Zasilni zakol",
  "elimination.reason.fertilityIssues": "Plodnostne motnje",
  "elimination.reason.poorProductionResults": "Slabi proizvodni rezultati",
  "elimination.reason.saleForBreeding": "Prodaja za pleme",
  "elimination.reason.beastDogAttack": "Napad zveri in psov",
  "elimination.reason.unknown": "Neznan",
  "elimination.reason.sale": "Prodaja",
  "elimination.reason.age": "Starost",
  "elimination.reason.infertility": "Neplodnost",
  "elimination.reason.lowProductivity": "Nizka produktivnost",
  "elimination.reason.breederResignedFromControl":
    "Rejec je izstopil iz kontrole",
  "elimination.reason.naturalDisasterLightning": "Naravne nesreče - strela",
  "elimination.reason.naturalDisasterFire": "Naravne nesreče - požar",
  "elimination.reason.eliminationTse": 'Izločitev zaradi "TSE"',
  "elimination.reason.seedNotAvailable": "Seme ni več na voljo",
  "elimination.reason.naturalDisasterLandSlide": "Naravne nesreče - plaz",
  "elimination.reason.euthanasia": "Naravne nesreče - evtanazija",

  "inbreedingCalculation.title":
    "Izračun koeficienta inbreeding-a pri drobnici",
  "inbreedingCalculation.description": "Izračun sorodstva",

  "relocation.title": "Premik",
  "relocation.description": "Selitev živali med lokacijami",

  "sale.title": "Prodaja (premik)",
  "sale.description": "Evidentiranje prodaje prašičev",

  "testStationInvoice.title": "Priprava predračuna",
  "testStationInvoice.description": "Dokumenti za transport",
  "testStationInvoice.data": "Podatki naročilnice",
  "testStationInvoice.preparingInvoice":
    "Priprava predračuna za odkup jagnjet na podlagi teže in cene iz šifranta",
  "testStationInvoice.date": "Datum naročilnice",
  "testStationInvoice.purchaseGroup": "Skupina odkupa",
  "testStationInvoice.ppsElement": "PPS ELEMENT",
  "testStationInvoice.operator": "Izvajalec",
  "testStationInvoice.priceList": "Cenik",
  "testStationInvoice.pricePerKg": "Cena na kg (€)",
  "testStationInvoice.weightSum": "Skupna teža",
  "testStationInvoice.priceSum": "Skupna cena",
  "testStationInvoice.value": "Vrednost (€)",
  "testStationInvoice.cubList": "Seznam mladičev",
  "testStationInvoice.fixedPriceFromCode": "Fiksna cena iz šifranta",
  "testStationInvoice.currentPriceForPeriod":
    "Trenutna cena iz šifranta za obdobje {{period}}: €{{pricePerKg}}/kg. Spremembe se izvajajo samo v šifrantu.",
  "testStationInvoice.noPriceCurrentlyValid":
    "Napaka: na današnji dan ni veljavna nobena cena.",
  "testStationInvoice.purchaseGroupHasNoAnimalsError":
    "Napaka: Skupina odkupa ne vsebuje nobene živali",
  "testStationInvoice.validFromTo":
    "Veljavnost od {{startDate}} do {{endDate}}",
  "testStationInvoice.selectPurchaseGroupFirst":
    "Najprej je potrebno izbrati skupino odkupa",
  "testStationInvoice.additionalPurchaseNotes": "Dodatne opombe o odkupu",
  "testStationInvoice.documentStatus": "Status dokumenta",
  "testStationInvoice.canBeGeneratedWhenSaved":
    "Pred generiranjem je potrebno predračun shraniti",
  "testStationInvoice.saveInvoice": "Shrani predračun in generiraj dokument",

  "testStationInvoice.important.onlyAuthorized":
    "Predračun lahko pripravi samo pooblaščen uporabnik (Testna postaja)",
  "testStationInvoice.important.priceFromCode":
    "Cena na kg se pridobi iz šifranta cen in je fiksna za posamezno obdobje",
  "testStationInvoice.important.automaticCalculation":
    "Skupna vrednost se izračuna avtomatsko: teža (kg) × cena na kg",
  "testStationInvoice.important.saveAsPdf":
    "Predračun je možno shraniti kot PDF in ga izvoziti/poslati rejcu",
  "testStationInvoice.important.noChangesAfterGenerating":
    "Po generiranju dokumenta nadaljnje spremembe niso več dovoljene",
  "testStationInvoice.important.moveToBackendManually":
    "Predračun se lahko kasneje ročno prenese v zaledni sistem (SAP)",
  "testStationInvoice.createError":
    "Prišlo je do napake pri ustvarjanju predračuna",
  "testStationInvoice.createSuccess": "Predračun je bil uspešno ustvarjen",
  "testStationInvoice.invoiceAlreadyCreated":
    "Predračun za izbrano odkupno skupino in rejca je bil že ustvarjen. Ponovno ustvarjanje predračuna ni mogoče",

  "testStationBloodAnalysis.title": "Krvna analiza",
  "testStationBloodAnalysis.description": "Laboratorijske preiskave",

  "treatment.title": "Tretiranje",
  "treatment.description": "Uporaba zdravil in preparatov",

  "weighing.title": "Tehtanje",
  "weighing.description": "Telesne meritve",

  "backMuscleMeasurement.title": "Meritve hrbtne mišice",
  "backMuscleMeasurement.description": "Meritve plemenskih karakteristik",

  "qualityClassification.title": "Določitev kakovostnega razreda",
  "qualityClassification.description": "Razvrstitev živali po kakovosti",

  "settlement.title": "Naselitev",
  "settlement.description": "Sprejem živali na TP lokacijo",

  "seed.title": "Seme",
  "seed.save": "Shrani",
  "seed.description": "Odvzem in evidence semena",
  "seed.smallLivestockSubtitle":
    "Zajem in shranjevanje rezultatov analize semena pri ovnih na testni postaji",
  "seed.basicAnalysis": "Osnovna analiza",
  "seed.morphology": "Morfologija semena",
  "seed.history": "Zgodovina odvzemov",
  "seed.basicData": "Osnovni podatki",
  "seed.animalSeedData": "Podatki o živali in odvzemu semena",
  "seed.physicalParameters": "Fizični parametri",
  "seed.testicleCircumference": "Obseg mod",
  "seed.testicleVolume": "Volumen",
  "seed.motility": "Gibljivost",
  "seed.progressiveMotility": "%PG (progresivno)",
  "seed.percentLessMotile": "%MG (manj gibljivi)",
  "seed.percentImmotile": "%NG (negibljivi)",
  "seed.motilitySumLessThanOneHundred": "Vsota gibljivosti ≤ 100%",
  "seed.density": "Gostota",
  "seed.cells": "Celice",
  "seed.additionalMeasurements": "Dodatne meritve",
  "seed.sumMustBeOneHundred": "Vsota mora biti 100%. Trenutna vsota {{value}}%",
  "seed.motilitySumValidation": "Vsota vseh gibljivosti mora biti 100%",
  "seed.notes": "Opombe",
  "seed.additionalNotes": "Dodatne opombe",
  "seed.sequenceNumber": "Zaporedna št. odvzema/vzorca",
  "seed.dateTaken": "Datum odvzema",
  "seed.recordDate": "Datum popisa",
  "seed.repeatedTake": "Ponovitev",
  "seed.detailedMorphology": "Detajlna morfološka analiza spermija",
  "seed.seedMorphology": "Morfologija semena",
  "seed.createMorphologyError":
    "Prišlo je do napake pri ustvarjanju morfologije",
  "seed.createMorphologySuccess":
    "Morfologija semena je bila uspešno ustvarjena",
  "seed.updateMorphologySuccess":
    "Morfologija semena je bila uspešno ustvarjena",
  "seed.morphologyDate": "Datum morfologije",
  "seed.normalPercent": "Normalni",
  "seed.headDefectPercent": "Glava",
  "seed.acrDetachedPercent": "Acr. odlep.",
  "seed.acrPeelingPercent": "Acr. v odlep.",
  "seed.acrDefectPercent": "Acr. def.",
  "seed.neckPercent": "Vrat",
  "seed.mpPercent": "MP",
  "seed.repPercent": "Rep",
  "seed.pdProxPercent": "PD-prox",
  "seed.pdMidPercent": "PD-mid",
  "seed.pdDistPercent": "PD-dist",
  "seed.multiPercent": "Multi",
  "seed.previousAnalyses": "Predhodne analize",
  "seed.previousAnalysesOverview": "Pregled preteklih odvzemov in analiz",
  "seed.date": "Datum",
  "seed.seqNum": "Zap. št.",
  "seed.normal": "Normalni",
  "seed.selectAnimalToSeeHistory":
    "Za ogled zgodovine izberite žival v zgornji tabeli ali v zavihku Osnovna analiza.",
  "seed.epithelial": "Epilene",
  "seed.leukocytes": "Levkociti",
  "seed.erythrocytes": "Eritrociti",
  "seed.morphologyNotYetEntered": "Potrebno je izpolniti še morfologijo semena",
  "seed.ksp": "KSP (mm)",
  "seed.dsp": "DSP (mm)",
  "seed.nr": "NR (cm)",
  "seed.rs": "RS (cm)",
  "seed.document": "Dokument izvida",
  "seed.averageDensity": "Aritmetična sredina gostote",
  "seed.nrOfDoses": "Št. doz",
  "seed.numberOfSpermCells": "Št. semenčic",
  "seed.pastSamples": "Predhodni vzorci semena",
  "seed.pastSamplesForHog": "Zgodovina odvzemov in pregledov za merjasca",
  "seed.sequenceNum": "Zap. št.",
  "seed.maxThreeSamplesShown":
    "Prikazani so zadnji 3 vzorci. Celotna zgodovina je dostopna v kartici merjasca.",
  "seed.morphologyCantBeSaved":
    "Morfologije ni mogoče shraniti brez predhodno vnesene osnovne analize odvzema. Izberite eno izmed obstoječih analiz iz zgornje tabele ali zavihka Osnovna analiza.",

  "physicalAssessment.title": "Telesne ocene",
  "physicalAssessment.description": "Morfološke in funkcionalne ocene",

  "eliminationTestStation.title": "Izločitev / Premik TP",
  "eliminationTestStation.description": "Izločitev ali premik živali na TP",
  "eliminationTestStation.elimination": "Izločitev",
  "eliminationTestStation.relocation": "Premik",
  "eliminationTestStation.relocationFromTestStation":
    "Premik živali iz testne postaje",
  "eliminationTestStation.saveRelocation": "Shrani premik",
  "eliminationTestStation.saveElimination": "Shrani izločitev",
  "eliminationTestStation.eliminationDescription": "Izločitev živali na TP",
  "eliminationTestStation.selectAnimals": "Izbera živali za izločitev",
  "eliminationTestStation.selectAnimalsForRelocation":
    "Izbera živali za premik",
  "eliminationTestStation.selectOneOrMoreAnimals":
    "Izberite eno ali več živali, ki jih želite izločiti s testne postaje",
  "eliminationTestStation.selectOneOrMoreAnimalsForRelocation":
    "Izberite eno ali več živali, ki jih želite premakniti iz TP",
  "eliminationTestStation.selectedAnimals": "Izbrane živali",
  "eliminationTestStation.selected": "Izbrano",
  "eliminationTestStation.elimenationData": "Podatki o izločitvi",
  "eliminationTestStation.enterEliminationData":
    "Vnesite podatke o izločitvi izbranih živali",
  "eliminationTestStation.toRelocation": "Naprej na premik",
  "eliminationTestStation.selectedAnimalsForRelocation":
    "Izbrane živali za premik",
  "eliminationTestStation.listOfRelocatedAnimals":
    "Seznam živali, ki bodo premaknjene na novo lokacijo",
  "eliminationTestStation.relocationData": "Podatki o premiku",
  "eliminationTestStation.enterRelocationData":
    "Vnesite podatke o premiku živali na novo lokacijo",
  "eliminationTestStation.backToElimination": "Nazaj na izločitev",
  "eliminationTestStation.confirmEliminationAndRelocation":
    "Potrdi izločitev in premik",

  "eliminationTestStation.businessRules.eliminationAndRelocationAreRelated":
    "Izločitev in premik sta obvezno povezana dogodka",
  "eliminationTestStation.businessRules.selectOneOrMore":
    "Izbiramo lahko eno ali več živali hkrati",
  "eliminationTestStation.businessRules.statusChangesToEliminated":
    'Status živali se ob izločitvi spremeni na "Izločena"',
  "eliminationTestStation.businessRules.relocationFollowsElimination":
    "Premik sledi izločitvi in žival premakne na določeno lokacijo",
  "eliminationTestStation.businessRules.writtenInRecords":
    "Pri negativnih ocenah, bolezni ali poginu se to zabeleži v evidenci",
  "eliminationTestStation.businessRules.animalUsuallyReturnedToBreeder":
    "Ob zaključku testiranja se živali običajno vračajo rejcem",

  "pagination.nextPage": "Naslednja stran",
  "pagination.next": "Naslednja stran",
  "pagination.previousPage": "Prejšnja stran",
  "pagination.pageSize": "Število na stran",

  "dataSource.TEST_STATION": "Testna postaja (TP)",
  "dataSource.TERRAIN": "Terenska ocena",

  "bodyExterior.EXCELLENT": "Odlična",
  "bodyExterior.VERY_GOOD": "Zelo dobra",
  "bodyExterior.GOOD": "Dobra",
  "bodyExterior.SATISFACTORY": "Zadovoljiva",
  "bodyExterior.UNSATISFACTORY": "Nezadovoljiva",

  "qualityGrade.2A": "2A",
  "qualityGrade.2B": "2B",
  "qualityGrade.3A": "3A",
  "qualityGrade.3B": "3B",

  // KMG Entity
  "kmgEntity.kmgName": "Ime rejca",
  "kmgEntity.kmgSurname": "Priimek",
  "kmgEntity.kmgAddress": "Naslov",
  "kmgEntity.kmgCountry": "Država",
  "kmgEntity.kmgPost": "Pošta",
  "kmgEntity.kmgPhone": "Telefon",
  "kmgEntity.institution": "Zavod (KGZ)",
  "kmgEntity.farmName": "Naziv posestva",

  // Executor
  "executor.breeder": "Rejec",
  "executor.controller": "Kontrolor",
  "executor.bf": "BF",
  "executor.ulBf": "UL BF",

  "modal.areYouSure": "Ali ste prepričani?",
  "modal.yes": "Da",
  "modal.no": "Ne",
  "modal.resetConfirmation":
    "Ali ste prepričani, da želite ponastaviti spremembe na obrazcu?",
  "modal.deleteTemplateConfirmation":
    "Ali ste prepričani da želite izbrisati predlogo?",
  "modal.deletePlaceholderConfirmation":
    "Ali ste prepričani da želite izbrisati ključnik?",
  "modal.deleteConfirmation": "Ali ste prepričani da želite izbrisati vnos?",

  "purchase.route.title": "Odkup mladičev",
  "purchase.purchase": "Odkup mladičev",
  "purchase.purchaseLoggingForTestStation":
    "Beleženje odkupa jagnjet za testno postajo",
  "purchase.automaticAnimalMoveOnSubmit":
    "Ob potrditvi odkupa se samodejno sproži premik živali v karanteno in izločitev iz rejčeve evidence.",
  "purchase.breeder.seller": "Rejec prodajalec (od kod gredo živali)",
  "purchase.breeder.sellerInformation": "Podatki o rejcu, ki prodaja živali",
  "purchase.breeder.buyer": "Rejec kupec (kamor gredo živali)",
  "purchase.breeder.buyerInformation": "Podatki o rejcu, ki odkupuje živali",
  "purchase.purchaseInformation": "Podatki o odkupu",
  "purchase.additionalInformation": "Datum popisa, odkupa in skupina",
  "purchase.purchaseOnlyPossibleWithRoleTestStation":
    "Odkup se izvaja izključno preko vloge Testna postaja",
  "purchase.lambMustBeMale": "Jagnje mora biti moškega spola",
  "purchase.inbreedingCoefficientMustBeBelow":
    "Inbreeding koeficient mora biti F < 6,25%",
  "purchase.pedigreeMustBeCorrectlyFilled":
    "Rodovnik mora biti pravilno izpolnjen",
  "purchase.lambsMustBeWeighedAtPurchase":
    "Jagnjeta morajo biti stehtana ob odkupu",
  "purchase.onConfirmationAnimalMoveToQuarantineIsStartedAndEliminationFromBreederRecords":
    "Ob potrditvi odkupa se sproži premik v karanteno in izločitev pri rejcu",
  "purchase.oneAnimalCanBePurchasedOnlyOnced":
    "Ena žival se lahko odkupi samo enkrat",
  "purchase.ifLambDoesntHaveIdTemporaryIdIsGeneratedAutomatically":
    "Če jagnje nima ID, se mu dodeli začasna številka",
  "purchase.eligibleLambs": "Upravičena jagnjeta ({{count}})",

  "disease.OVINE_EPIDIDYMITIS": "Ovčji epididimitis",
  "disease.PARATUBERCULOSIS": "Paratuberkuloza",
  "disease.BRUCELLOSIS": "Bruceloza",
  "disease.BLUETONGUE": "Modri jezik",
  "disease.ENZOOTIC_ABORTION_OF_EWES": "Enzootsko zvrgavanje ovac",
  "disease.Q_FEVER": "Mrzlica Q",
  "disease.MAEDI_VISNA": "Maedi/Visna",

  "testStatus.NEGATIVE": "(-) negativno",
  "testStatus.POSITIVE": "(+) pozitivno",
  "testStatus.QUESTIONABLE": "(?) vprašljivo",
  "testStatus.NOT_DONE": "(o) ni opravljeno",

  "drawer.home": "Domov",
  "drawer.templates": "Predloge",
  "drawer.placeholders": "Ključniki",
  "drawer.animalOverview": "Pregled živali",

  "search.results": "Rezultati iskanja",
  "search.noResultsFound": "Ni najdenih rezultatov",
  "search.unknownTitle": "Neznano",

  "validation.dateNotInFuture": "Datum ne sme biti v prihodnosti",

  generate: "Generiraj",
  "validation.required": "To polje je obvezno",
  "validation.number": "Vnesi veljavno številko",
  "validation.min": "Vrednost mora biti večja ali enaka {{min}}",
  "validation.max": "Vrednost mora biti manjša ali enaka {{max}}",
  "validation.maxLength": "Največja dolžina je {{max}} znakov",
  "validation.startDateCannotBeBeforeDecisionDate":
    "Datum začetka prepovedi ne sme biti pred datumom odločitve",
  "validation.endDateCannotBeBeforeStartDate":
    "Datum konca prepovedi ne sme biti pred datumom začetka",
  "validation.animalRequired": "Izberite žival",
  "validation.dateCannotBeInFuture": "Datum ne sme biti v prihodnosti",
  "validation.letoDoGteLetoOd": "Leto do mora biti večje ali enako letu od",
  "validation.max50YearsDifference":
    "Razlika med letoma je lahko največ 50 let",

  "validation.percentageRange": "{{field}} mora biti med {{min}}% in {{max}}%",
  "validation.dateOnOrAfterWeighingDate":
    "Datum popisa ne sme biti pred datumom tehtanja",
  "validation.startDateMustBeAfterBirthDate":
    "Datum začetka molže mora biti večji ali enak datumu kotitve.",
  "validation.startDateMustBeAfterBirthDateList":
    "Datum začetka molže mora biti večji ali enak datumu kotitve za naslednje živali: {{animals}}.",
  "validation.startDateMustBeBeforeEndDate":
    "Datum konca molže mora biti večji od datuma začetka molže.",
  "validation.startDateMustBeBeforeEndDateList":
    "Datum konca molže mora biti večji od datuma molže za naslednje živali: {{animals}}.",
  "validation.inActiveSale": "Žival je že v procesu prodaje",
  "validation.inThisActiveSale": "Žival je že vključena v izbrano prodajo",
  "validation.mladiciOcenaSumDetail":
    "Vsota mladičev z ocenami (1: {{ocena1}}, 2: {{ocena2}}, 3: {{ocena3}}) = {{sum}} mora biti manj ali enako številu živorojenih mladičev ({{steviloZivorojenih}}).",
  "validation.dateBeforeBirthOrBrandingForAnimals":
    "Datum prodaje ne sme biti pred rojstvom ali označitvijo za naslednje živali: {{animals}}",
  "validation.dateBeforeBranding":
    "Datum prodaje ne sme biti pred datumom rojstva živali",
  "validation.dateBeforeBirth":
    "Datum prodaje ne sme biti pred datumom označitve živali",
  "validation.dateBeforeBirthOrBranding":
    "Datum prodaje ne sme biti pred rojstvom ali označitvijo za izbrane živali",
  "validation.purposeRequired": "Namen prodaje je obvezen",
  "validation.purposeRequiredForAnimals":
    "Namen prodaje je obvezen za naslednje živali: {{animals}}",
  "validation.minDateOfWeaningAfterBranding":
    "Datum odstavitve mora biti po datumu označitve",
  "validation.maxMarkedPiglets": "Število presega število označenih pujskov",
  "validation.minDateOfWeaning": "Datum prejema mora biti po datumu odstavitve",
  "validation.sowAlreadyHadWeaningForLitter":
    "Samica je že odstavila vse mladiče iz izbranega legla. Nova odstavitev ni mogoča",
  "validation.exceedsMarkedPiglets":
    "Število odstavljenih mladičev presega število označenih mladičev",
  "validation.remainingPiglets":
    "Število mladičev na voljo za odstavitev: {{remaining}}",
  "validation.attachmentRequiredWhenConfirmed":
    "Dokumentacija/prodajni list je obvezen za potrditev prodaje",
  "validation.saleForInvalidAnimals":
    "Odprta prodaja vključuje živali, ki niso več aktivne ({{animals}}). Urejanje in potrjevanje prodaje ni mogoče.",
  "validation.receivedDateMustBeAfterBrandingDate":
    "Datum prejema ne sme biti pred datumom označitve",
  "validation.maxDecimals":
    "Vrednost lahko vsebuje največ {{value}} decimalna mesta",
  "validation.censusDateMustBeAfterReceivedDate":
    "Datum popisa mora biti kasnejši od datuma prejema",
  "validation.censusDateMustBeAfterBrandingDate":
    "Datum popisa mora biti kasnejši od datuma označitve",
  "validation.temporaryOrAnimalIdRequired": "Vnesi ušesno ali začasno številko",

  "breedingStatuses.previousBreedingStatuses": "Predhodni rejski statusi",
  "breedingStatuses.previousBreedingStatusesDescription":
    "Pregled preteklih rejskih statusov za izbranega rejca",
  "breedingStatuses.noPreviousBreedingStatusesForSelectedBreeder":
    "Ni predhodnih rejskih statusov za izbranega rejca.",
  "breedingStatuses.noPreviousBreedingStatuses":
    "Ni najdenih predhodnih rejskih statusov.",
  "breedingStatuses.list": "Seznam rejskih statusov",
  "breedingStatuses.listDescription": "Pregled vseh dodanih rejskih statusov.",
  "breedingStatuses.create": "Dodaj nov rejski status",
  "breedingStatuses.notFutureDate": "Datum določitve ne sme biti v prihodnosti",

  "sif.statusReje": "Status reje",

  notFutureDate: "Datum ne sme biti v prihodnosti",
  "animal.earTagId": "ID živali",
  "animal.tempAnimalId": "Začasna št.",
  "header.home": "Domov",
  close: "Zapri",
  "common.close": "Zapri",
  "common.saveDraft": "Shrani osnutek",
  "common.saveConfirm": "Potrdi in shrani",
  "form.autoGenerated": "Avtomatsko generirano",
  "notification.success": "Uspešno",
  error: "Napaka",
  success: "Uspešno",
  code: "Šifra",
  description: "Opis",
  "common.warning": "Opozorilo",
  "common.dismiss": "Skrij opozorilo",
  "common.select": "Izberi",
  "common.male": "Samec",
  "common.unknownError": "Neznana napaka",
  "validation.fixErrors": "Odpravite napake pred shranjevanjem",
  "validation.birthBeforeCensus": "Datum rojstva mora biti pred datumom popisa",
  "validation.parent.required": "Starš je obvezen",
  "validation.parent.requiredHint":
    "Za potrditev vnosa je potrebno vnesti vsaj enega starša",
  "validation.species.mismatch": "Vrsta živali se ne ujema",
  "validation.breed.mismatch": "Pasma se ne ujema",
  "validation.origin.missing": "Izvor ni vnešen",
  "validation.parent.birth.afterChild":
    "Datum rojstva starša mora biti pred datumom rojstva mladiča",
  "validation.warnings.title": "Opozorila",
  "validation.warnings.confirmHint":
    "Kljub opozorilom lahko nadaljujete s potrditvijo",
  "form.selectAnimals": "Izberite živali",
  "form.searchByIdOrName": "Išči po ID ali imenu",
  "form.breederRequired": "Rejec je obvezen",
  "form.maxNumberOfCubs": "Največje dovoljeno število mladičev",
  "form.featureBeingImplemented": "Funkcionalnost v izdelavi",
  "form.inputMustBeInteger": "Vrednost mora biti celo število",
  "animal.parentUnknown": "Neznano",

  "documents.pedigreeBook": "Rodovniška knjiga",
  "documents.pedigreeBookDescription": "Vpogled v rodovniške knjige",

  "pedigree.pedigreeIdentifier": "Vpisna št. v RK",
  "pedigree.dateOfEntry": "Datum vpisa",
  "pedigree.validUntil": "Datum veljavnosti",
  "pedigree.class": "Razred RK",
  "pedigree.section": "Razdelek",
  "pedigree.notes": "Opombe",
  "pedigree.fatherOfFatherEarTagNumber": "Oče očeta",
  "pedigree.motherOfFatherEarTagNumber": "Mati očeta",
  "pedigree.fatherOfMotherEarTagNumber": "Oče matere",
  "pedigree.motherOfMotherEarTagNumber": "Mati matere",
  "pedigree.parentsAndGrandparents": "Starši in stari starši",
  "pedigree.pedigreeBook": "Rodovniška knjiga",
  "pedigree.prefix": "Predpona",
  "pedigree.title": "Naziv",
  "pedigree.code": "Šifra",
  "pedigree.lastSequenceNumber": "Zadnja zap. št. ",
  "pedigree.programTitle": "Naziv rejskega programa",
  "pedigree.programCode": "Šifra rejskega programa",
  "pedigree.pedigreeBookOverview": "Pregled nad rodovniškimi knjigami",
  "pedigree.list": "Seznam rodovniških knjig",
  "pedigree.listOfAnimals": "Seznam živali vpisanih v rodovniško knjigo",

  "purpose.REPRODUCTION": "Razmnoževanje",
  "purpose.FATTENING": "Pitanje",

  "section.smallLivestock": "DROBNICA",
  "section.pigs": "PRAŠIČI",
  "section.horses": "KOPITARJI",

  "theme.search.searching": "Iskanje",

  "status.ODPRTA": "Odprta prodaja",
  "status.POTRJENA": "Potrjena prodaja",

  "authorization.noAccess":
    "Dostop zavrnjen. Nimate ustreznih pravic za ogled te strani. Če menite, da gre za napako, se obrnite na skrbnika sistema ali podporo.",
  "authorization.readOnlyAccess":
    "Dostop zavrnjen. Uporabnik nima nastavljenih pravic za ustvarjanje novih vnosov in urejanje.",

  "form.createPedigreeNumber": "Shrani končno rodovniško številko",

  "sampleCollection.title": "Odvzem vzorcev in pošiljanje v laboratorij",
  "sampleCollection.modal.title": "Evidentiranje rezultatov",
  "sampleCollection.description":
    "Upravljanje z odvzemom bioloških vzorcev, pošiljanjem v laboratorij in evidentiranjem rezultatov",
  "sampleCollection.tabs.collected": "Odvzeti vzorci",
  "sampleCollection.tabs.collectedDescription":
    "Seznam vseh odvzetih vzorcev, ki še niso bili poslani v laboratorij",
  "sampleCollection.tabs.shipped": "Pošiljke vzorcev v laboratorij",
  "sampleCollection.tabs.shippedDescription":
    "Seznam vseh poslanih vzorcev v laboratorij",
  "sampleCollection.tabs.resultsReceived":
    "Pošiljke vzorcev v lab. s prejetimi izvidi",
  "sampleCollection.tabs.resultsReceivedDescription":
    "Seznam vzorcev za katere so prejeti rezultati",
  "sampleCollection.route.title": "Odvzem vzorcev in pošiljanje v laboratorij",
  "sampleCollection.actions.update": "Posodobi",
  "sampleCollection.actions.save": "Shrani odvzem vzorca",
  "sampleCollection.actions.create": "Dodaj odvzem vzorca",

  "sampleCollection.newSample": "Odvzem novega vzorca",
  "sampleCollection.newSampleDescription": "Vnos novega odvzema vzorca",
  "sampleCollection.editSample": "Uredi vzorec",
  "sampleCollection.editSampleDescription": "Uredi podatke o odvzetem vzorcu",
  "sampleCollection.viewSample": "Pogled vzorca",
  "sampleCollection.viewSampleDescription": "Pogled podatkov o odvzetem vzorcu",
  "sampleCollection.sampleCreated": "Vzorec je bil uspešno dodan",
  "sampleCollection.sampleUpdated": "Vzorec je bil uspešno posodobljen",
  "sampleCollection.sendToLab": "Pošlji v laboratorij",
  "sampleCollection.shipmentDetails": "Podatki o pošiljki",
  "sampleCollection.labResults": "Rezultati laboratorija",
  "sampleCollection.labResultsDetails": "Podatki o rezultatih",
  "sampleCollection.shipmentCreated": "Pošiljka je bila uspešno ustvarjena",
  "sampleCollection.recordResults": "Evidentiraj rezultate",
  "sampleCollection.resultsRecorded": "Rezultati so bili uspešno evidentirani",
  "sampleCollection.selectedCount": "Izbranih vzorcev: {{count}}",
  "sampleCollection.noSamples": "Ni odvzetih vzorcev",
  "sampleCollection.noShippedSamples": "Ni poslanih vzorcev",
  "sampleCollection.noResultsReceived": "Ni prejetih rezultatov",

  "sampleCollection.sendToLabModal.title": "Pošiljanje vzorcev v laboratorij",
  "sampleCollection.sendToLabModal.selectedSamples":
    "Izbranih vzorcev: {{count}}",
  "sampleCollection.recordResultsModal.title": "Evidentiranje rezultatov",

  "sampleCollection.sampleNumber": "Oznaka vzorca",
  "sampleCollection.animalId": "ID živali",
  "sampleCollection.breeder": "Rejec",
  "sampleCollection.sampleType": "Odvzet material",
  "sampleCollection.collectionDate": "Datum odvzema",
  "sampleCollection.collectedBy": "Odvzel",
  "sampleCollection.shipmentNumber": "Oznaka posodice",
  "sampleCollection.laboratory": "Laboratorij",
  "sampleCollection.shipmentDate": "Datum odpošiljanja",
  "sampleCollection.resultsReceivedDate": "Datum prejema izvidov",
  "sampleCollection.sampleCount": "Št. vzorcev",
  "sampleCollection.resultsCount": "Rezultati",
  "sampleCollection.status": "Status",
  "sampleCollection.sequentialNumber": "Zaporedni odvzem",
  "sampleCollection.receiptDate": "Datum prejema",
  "sampleCollection.markingDate": "Datum označevanja",
  "sampleCollection.genotypeDate": "Datum genotipizacije",
  "sampleCollection.genotypeSuccess": "Uspešnost genotipizacije",
  "sampleCollection.oznakaCipa": "Oznaka čipa",
  "sampleCollection.notes": "Opombe",
  "sampleCollection.collector": "Odvzel",
  "sampleCollection.resultsReceived": "Rezultati prejeti",
  "sampleCollection.pendingResults": "Čakajo na rezultate",

  "sampleCollection.validation.collectionDateMustBeAfterReceiptDate":
    "Datum prejema mora biti po datumu odvzema",
  "sampleCollection.validation.markingDateAfterCollectionDate":
    "Datum označevanja mora biti enak ali kasnejši od datuma odvzema za vse izbrane vzorce",
  "sampleCollection.validation.markingDateAfterReceiptDate":
    "Datum označevanja mora biti enak ali kasnejši od datuma prejema za vse izbrane vzorce",
  "sampleCollection.validation.sentDateAfterCollectionDate":
    "Datum odpošiljanja mora biti enak ali kasnejši od datuma odvzema za vse izbrane vzorce",
  "sampleCollection.validation.sentDateAfterReceiptDate":
    "Datum odpošiljanja mora biti enak ali kasnejši od datuma prejema za vse izbrane vzorce",
  "sampleCollection.validation.sentDateAfterMarkingDate":
    "Datum odpošiljanja mora biti enak ali kasnejši od datuma označevanja",
  "sampleCollection.validation.genotypeDateAfterSentDate":
    "Datum genotipizacije mora biti enak ali kasnejši od datuma pošiljanja vzorca",
  "sampleCollection.validation.genotypeDateBeforeResultsDate":
    "Datum genotipizacije mora biti enak ali zgodnejši od datuma prejema izvida",
  "sampleCollection.validation.resultsReceivedDateAfterSentDate":
    "Datum prejema izvidov mora biti enak ali kasnejši od datuma pošiljanja vzorca",

  "admin.breeds.title": "Administracija pasem",
  "admin.breeds.description":
    "Pregled, urejanje in spremljanje pasemskih klasifikacij.",
  "admin.breeds.tabs.classifications.label": "Klasifikacije",
  "admin.breeds.tabs.compositions.label": "Sestave",
  "admin.breeds.tabs.calculations.label": "Izračun",

  "admin.breeds.classifications.list.title": "Pasemske klasifikacije",
  "admin.breeds.classifications.list.subTitle": "Seznam pasemskih klasifikacij",

  "admin.breeds.classifications.columns.sifra": "Šifra",
  "admin.breeds.classifications.columns.numericnaSifra": "Numerična šifra",
  "admin.breeds.classifications.columns.name": "Naziv",
  "admin.breeds.classifications.columns.breedProgram": "Rejski program",
  "admin.breeds.classifications.columns.pedigreeBook": "Rodovniška knjiga",
  "admin.breeds.classifications.columns.kratica": "Kratica",
  "admin.breeds.classifications.columns.species": "Vrsta",
  "admin.breeds.classifications.columns.status": "$t(status)",
  "admin.breeds.classifications.columns.createdOn": "Ustvarjeno",
  "admin.breeds.classifications.columns.createdBy": "Avtor",

  "admin.breeds.classifications.filter.species":
    "$t(admin.breeds.classifications.columns.species)",
  "admin.breeds.classifications.filter.status":
    "$t(admin.breeds.classifications.columns.status)",
  "admin.breeds.classifications.filter.pedigreeBook":
    "$t(admin.breeds.classifications.columns.pedigreeBook)",
  "admin.breeds.classifications.filter.name":
    "$t(admin.breeds.classifications.columns.name)",
  "admin.breeds.classifications.filter.code":
    "$t(admin.breeds.classifications.columns.sifra)",
  "admin.breeds.classifications.filter.abbreviation":
    "$t(admin.breeds.classifications.columns.kratica)",
  "admin.breeds.classifications.filter.numericCode":
    "$t(admin.breeds.classifications.columns.numericnaSifra)",
  "admin.breeds.classifications.filter.intermediateBreed": "Vmesna pasma",
  "admin.breeds.classifications.filter.breedingProgramExists":
    "$t(admin.breeds.classifications.columns.breedProgram)",

  "admin.breeds.calculations.list.title": "Pregled izračunov pasme živali",
  "admin.breeds.calculations.list.subTitle":
    "Pregled, filtriranje in razvrščanje izračunov glavne pasme in deležev",

  "admin.breeds.calculations.columns.usesnaStevilka": "$t(animal.animalId)",
  "admin.breeds.calculations.columns.zivalIme": "$t(animal.name)",
  "admin.breeds.calculations.columns.speciesSifra": "$t(animal.speciesSifra)",
  "admin.breeds.calculations.columns.mainBreed": "Glavna pasma",
  "admin.breeds.calculations.columns.share": "Delež ",
  "admin.breeds.calculations.columns.calculationDate": "Datum izračuna",
  "admin.breeds.calculations.columns.frozen": "Zamrznjena izračun",
  "admin.breeds.calculations.columns.frozenAndShares":
    "Zamrznjena izračun in deleži",
  "admin.breeds.calculations.columns.partsCount": "Št. deležev",
  "admin.breeds.calculations.columns.notes": "Opombe",

  "admin.breeds.calculations.filter.usesnaStevilka": "$t(animal.animalId)",
  "admin.breeds.calculations.filter.zivalIme": "$t(animal.name)",
  "admin.breeds.calculations.filter.speciesSifra": "$t(animal.speciesSifra)",
  "admin.breeds.calculations.filter.statusSifra": "Status živali",
  "admin.breeds.calculations.filter.calculationDate.since": "Datum izračuna od",
  "admin.breeds.calculations.filter.calculationDate.until": "Datum izračuna do",
  "admin.breeds.calculations.filter.frozen": "Zamrznjena izračun",
  "admin.breeds.calculations.filter.frozenAndShares":
    "Zamrznjena izračun in deleži",
  "admin.breeds.calculations.filter.notes": "Opombe",
  "admin.breeds.recalculation": "Preračun pasem - {{species}}",
  "admin.breeds.calculationSuccess":
    "Pasme so bile uspešno preračunane. Procesiranih: {{processed}}, preskočenih: {{skipped}}, napak: {{errors}}",
  "admin.breeds.calculationError": "Prišlo je do napake pri preračunu pasem",
  "admin.breeds.calculationEdit": "Urejanje izračuna pasem za žival",
  "admin.breeds.addNewFraction": "Dodaj nov delež",
  "admin.breeds.fraction": "Delež",
  "admin.breeds.calculationDate": "Datum izračuna",
  "admin.breeds.fractionFreeze": "Zamrznitev deleža",
  "admin.breeds.mainBreed": "Glavna pasma",
  "admin.breeds.saveCalculationSuccess": "Izračun je bil uspešno shranjen",
  "admin.breeds.saveCalculationError":
    "Prišlo je do napake pri shranjevanju izračuna",
  "admin.breeds.fractions": "Deleži pasem",
  "admin.breeds.noFractions": "Ni definiranih deležev",
  "admin.breeds.freezedCalculation": "Zamrznjen izračun",

  "admin.breeds.OVCA": "ovce",
  "admin.breeds.KOZA": "koze",
  "admin.breeds.PRASIC": "prašiči",

  "admin.breeds.compositions.list.title": "Pregled pasemskih sestav",
  "admin.breeds.compositions.list.subTitle":
    "Pregled, filtriranje in razvrščanje definiranih pasemskih sestav",

  "admin.breeds.compositions.columns.pasmaPotomca": "Pasma potomca",
  "admin.breeds.compositions.columns.pasmaOceta": "Pasma očeta",
  "admin.breeds.compositions.columns.pasmaMatere": "Pasma matere",
  "admin.breeds.compositions.columns.minDelezPasmeOceta": "Min. delež očeta",
  "admin.breeds.compositions.columns.minDelezPasmeMatere": "Min. delež matere",
  "admin.breeds.compositions.columns.veljaOd": "Velja od",
  "admin.breeds.compositions.columns.veljaDo": "Velja do",
  "admin.breeds.compositions.filter.pasmaPotomca": "Pasma potomca",
  "admin.breeds.compositions.filter.pasmaOceta": "Pasma očeta",
  "admin.breeds.compositions.filter.pasmaMatere": "Pasma matere",
  "admin.breeds.compositions.filter.minDelezPasmeOceta": "Min. delež očeta",
  "admin.breeds.compositions.filter.minDelezPasmeMatere": "Min. delež matere",

  "ocenjevalni-listi/new": "Ustvari nov ocenjevalni list",
  "ocenjevalni-listi/copy": "Kopiraj ocenjevalni list",
  "admin.ocenjevalni-listi.list.title": "Ocenjevalni listi",
  "admin.ocenjevalni-listi.list.subtitle": "Seznam predlog ocenjevalnih listov",
  "admin.ocenjevalni-listi.list.column.id": "ID",
  "admin.ocenjevalni-listi.list.column.name": "Naziv",
  "admin.ocenjevalni-listi.list.column.assessmentType": "Vrsta ocenjevanja",
  "admin.ocenjevalni-listi.list.column.calcMethod": "Izračun",
  "admin.ocenjevalni-listi.list.column.applicability": "Veljavnost",
  "admin.ocenjevalni-listi.list.column.updated": "Posodobljeno",
  "admin.ocenjevalni-listi.list.filter.name": "Naziv",
  "admin.ocenjevalni-listi.list.filter.assessmentType": "Vrsta ocenjevanja",
  "admin.ocenjevalni-listi.list.filter.species": "Vrsta",
  "admin.ocenjevalni-listi.list.filter.breed": "Pasma",
  "admin.ocenjevalni-listi.list.filter.gender": "Spol",
  "admin.ocenjevalni-listi.list.filter.stage": "Razvojni stadij",
  "admin.ocenjevalni-listi.list.applicability.species": "Vrsta",
  "admin.ocenjevalni-listi.list.applicability.breed": "Pasma",
  "admin.ocenjevalni-listi.list.applicability.gender": "Spol",
  "admin.ocenjevalni-listi.list.applicability.stage": "Razvojni stadij",
  "admin.ocenjevalni-listi.list.applicability.all": "Vse",
  "admin.ocenjevalni-listi.editor.title.edit":
    "Urejanje ocenjevalnega lista: {{name}}",
  "admin.ocenjevalni-listi.editor.title.copyBase": "Kopija ocenjevalnega lista",
  "admin.ocenjevalni-listi.editor.title.copy":
    "Kopija ocenjevalnega lista: {{id}}",
  "admin.ocenjevalni-listi.editor.title.create": "Nov ocenjevalni list",
  "admin.ocenjevalni-listi.editor.subtitle":
    "Urejanje predloge ocenjevalnega lista",
  "admin.ocenjevalni-listi.editor.tab.basic": "Osnovno",
  "admin.ocenjevalni-listi.editor.tab.applicability": "Veljavnost",
  "admin.ocenjevalni-listi.editor.tab.sections": "Sklopi",
  "admin.ocenjevalni-listi.editor.tab.fields": "Polja",
  "admin.ocenjevalni-listi.editor.basic.field.nameSl": "Naziv (SL)",
  "admin.ocenjevalni-listi.editor.basic.field.nameEn": "Naziv (EN)",
  "admin.ocenjevalni-listi.editor.basic.field.assessmentType":
    "Vrsta ocenjevanja",
  "admin.ocenjevalni-listi.editor.basic.field.calcMethod": "Metoda izračuna",
  "admin.ocenjevalni-listi.editor.basic.field.hasWeight":
    "Izračunaj tudi povprečno oceno ocenjevalnega ista",
  "admin.ocenjevalni-listi.editor.sections.sectionFallback": "Sklop {{number}}",
  "admin.ocenjevalni-listi.editor.sections.action.remove": "Odstrani sklop",
  "admin.ocenjevalni-listi.editor.sections.action.duplicate": "Podvoji sklop",
  "admin.ocenjevalni-listi.editor.sections.action.add": "Dodaj sklop",
  "admin.ocenjevalni-listi.editor.sections.duplicate.success":
    "Sklop {{name}} je bil uspešno kopiran. Kopiranih je bilo tudi {{fieldsCount}} polj.",
  "admin.ocenjevalni-listi.editor.sections.field.nameSl": "Naziv sklopa (SL)",
  "admin.ocenjevalni-listi.editor.sections.field.nameEn": "Naziv sklopa (EN)",
  "admin.ocenjevalni-listi.editor.sections.field.order": "Vrstni red",
  "admin.ocenjevalni-listi.editor.sections.field.columns": "Št. stolpcev",
  "admin.ocenjevalni-listi.editor.sections.field.group": "Skupina sklopa",
  "admin.ocenjevalni-listi.editor.sections.field.groupNew":
    "Nova skupina sklopa",
  "admin.ocenjevalni-listi.editor.sections.field.groupNewEn":
    "Nova skupina sklopa (EN)",
  "admin.ocenjevalni-listi.editor.sections.field.calcMethod": "Metoda izračuna",
  "admin.ocenjevalni-listi.editor.sections.field.docxTag": "Docx tag",
  "admin.ocenjevalni-listi.editor.sections.group.none":
    "Brez skupine / brez zavihkov",
  "admin.ocenjevalni-listi.editor.sections.group.new": "Ustvari novo skupino",
  "admin.ocenjevalni-listi.editor.docxTag.help":
    "Za izvoz v DOCX vnesi osnovni ključ brez končnic Ocena, Vrednost ali Komentar. Primer: VisinaKrizaOcena / VisinaKrizaVrednost / VisinaKrizaKomentar -> VisinaKriza. Če povezave ni, uporabi __NONE__.",
  "admin.ocenjevalni-listi.editor.sections.field.required": "Obvezno",
  "admin.ocenjevalni-listi.editor.sections.field.calculateAverageScoreSection":
    "Izračunaj tudi povprečno oceno sklopa",
  "admin.ocenjevalni-listi.editor.sections.field.calculateAverageList":
    "Izračunaj tudi povprečno oceno ocenjevalnega lista",
  "admin.ocenjevalni-listi.editor.sections.applicability": "Veljavnost sklopa",
  "admin.ocenjevalni-listi.editor.applicability.summary":
    "Povzetek veljavnosti",
  "admin.ocenjevalni-listi.editor.save.success":
    "Ocenjevalni list je uspešno shranjen.",
  "admin.ocenjevalni-listi.editor.confirmSave.title": "Potrditev shranjevanja",
  "admin.ocenjevalni-listi.editor.confirmSave.content":
    "S shranjevanjem boste shranili celoten ocenjevalni list, vključno z vsemi zavihki.",
  "admin.ocenjevalni-listi.editor.action.copy": "Ustvari kopijo",
  "admin.ocenjevalni-listi.editor.action.nextTab": "Naslednji zavihek",
  "admin.ocenjevalni-listi.editor.action.deleteDev": "Izbriši predlogo (DEV)",
  "admin.ocenjevalni-listi.editor.confirmDelete.title":
    "Potrditev brisanja predloge",
  "admin.ocenjevalni-listi.editor.confirmDelete.content":
    "V razvojnem načinu boste izbrisali celoten ocenjevalni list. Nadaljujte le, če ste prepričani.",
  "admin.ocenjevalni-listi.editor.fields.action.remove": "Odstrani polje",
  "admin.ocenjevalni-listi.editor.fields.action.preview":
    "Predogled komponente",
  "admin.ocenjevalni-listi.editor.fields.action.add": "Dodaj polje",
  "admin.ocenjevalni-listi.editor.fields.action.addCustomJson":
    "Dodaj komponento",
  "admin.ocenjevalni-listi.editor.fields.sectionCard.title":
    "Sklopi trenutnega ocenjevalnega lista",
  "admin.ocenjevalni-listi.editor.fields.sectionCard.subtitle":
    "Izberite sklop, za katerega želite urejati polja.",
  "admin.ocenjevalni-listi.editor.fields.section": "Sklop",
  "admin.ocenjevalni-listi.editor.fields.fieldFallback": "Polje {{number}}",
  "admin.ocenjevalni-listi.editor.fields.field.nameSl": "Naziv polja (SL)",
  "admin.ocenjevalni-listi.editor.fields.field.nameEn": "Naziv polja (EN)",
  "admin.ocenjevalni-listi.editor.fields.field.order": "Vrstni red",
  "admin.ocenjevalni-listi.editor.fields.field.type": "Tip",
  "admin.ocenjevalni-listi.editor.fields.field.type.TEXT": "Besedilo",
  "admin.ocenjevalni-listi.editor.fields.field.type.NUMBER": "Številka",
  "admin.ocenjevalni-listi.editor.fields.field.type.NUMBER-CALC": "Ocena",
  "admin.ocenjevalni-listi.editor.fields.field.type.DROPDOWN": "Seznam",
  "admin.ocenjevalni-listi.editor.fields.field.type.RADIO": "Radio gumb",
  "admin.ocenjevalni-listi.editor.fields.field.type.IMAGE": "Slika",

  "admin.ocenjevalni-listi.editor.fields.field.docxTag": "Docx tag",
  "admin.ocenjevalni-listi.editor.fields.field.description": "Opis",
  "admin.ocenjevalni-listi.editor.fields.field.targetValue": "Želena vrednost",
  "admin.ocenjevalni-listi.editor.fields.field.required": "Obvezno",
  "admin.ocenjevalni-listi.editor.fields.field.hasComment": "Ima komentar",
  "admin.ocenjevalni-listi.editor.fields.field.skipped":
    "Nepregledano / preskočeno",
  "admin.ocenjevalni-listi.editor.fields.field.lookupRef": "Izberi šifrant",
  "admin.ocenjevalni-listi.editor.fields.field.numberMin": "Min",
  "admin.ocenjevalni-listi.editor.fields.field.numberMax": "Max",
  "admin.ocenjevalni-listi.editor.fields.field.numberStep": "Korak",
  "admin.ocenjevalni-listi.editor.fields.field.weight": "Utež",
  "admin.ocenjevalni-listi.editor.fields.field.leftExtreme":
    "Biološki ekstrem levo",
  "admin.ocenjevalni-listi.editor.fields.field.leftExtremeEn":
    "Biološki ekstrem levo (EN)",
  "admin.ocenjevalni-listi.editor.fields.field.rightExtreme":
    "Biološki ekstrem desno",
  "admin.ocenjevalni-listi.editor.fields.field.rightExtremeEn":
    "Biološki ekstrem desno (EN)",
  "admin.ocenjevalni-listi.editor.fields.field.customJson":
    "CUSTOM_JSON konfiguracija",
  "admin.ocenjevalni-listi.editor.fields.applicability": "Veljavnost polja",
  "admin.ocenjevalni-listi.editor.fields.field.componentType":
    "Vrsta komponente",
  "admin.ocenjevalni-listi.editor.fields.field.componentTitle":
    "Naslov komponente",
  "admin.ocenjevalni-listi.editor.fields.field.componentDescription":
    "Opis komponente",
  "admin.ocenjevalni-listi.editor.fields.field.group": "Skupina polj",
  "admin.ocenjevalni-listi.editor.fields.group.new": "Nova skupina polj",
  "admin.ocenjevalni-listi.editor.fields.group.none": "Brez skupine",
  "admin.ocenjevalni-listi.editor.fields.field.groupNew": "Nova skupina polj",
  "admin.ocenjevalni-listi.editor.fields.field.groupNewEn":
    "Nova skupina polj (EN)",
  "admin.ocenjevalni-listi.editor.fields.component.info":
    "Informativni element",
  "admin.ocenjevalni-listi.editor.fields.component.markings": "Oris",
  "admin.ocenjevalni-listi.editor.fields.component.chestnuts": "Kostanci",
  "admin.ocenjevalni-listi.editor.fields.component.transponder": "Transponder",
  "admin.ocenjevalni-listi.editor.fields.component.signature": "Podpis",
  "admin.ocenjevalni-listi.editor.fields.component.selected":
    "Izbrana komponenta",
  "admin.ocenjevalni-listi.editor.fields.component.preview":
    "Predogled komponente",
  "admin.ocenjevalni-listi.editor.fields.component.info.help":
    "Vnesite vsebino informativnega elementa. Najprej izpolnite trenutno aktivni jezik, po potrebi pa nato še prevod.",
  "admin.ocenjevalni-listi.editor.fields.component.content":
    "Vsebina komponente",
  "admin.ocenjevalni-listi.editor.fields.component.translations":
    "Dodatni prevodi",
  "admin.ocenjevalni-listi.editor.fields.component.addTranslation":
    "Dodaj prevod ({{lang}})",
  "admin.ocenjevalni-listi.editor.fields.component.translationLanguage":
    "Jezik prevoda",
  "admin.ocenjevalni-listi.editor.fields.component.addTranslationAction":
    "Dodaj prevod",
  "admin.ocenjevalni-listi.editor.fields.component.removeTranslationAction":
    "Odstrani prevod",
  "admin.ocenjevalni-listi.editor.fields.component.primaryLanguage":
    "Privzeti jezik",
  "admin.ocenjevalni-listi.editor.fields.component.advancedJson":
    "Napredna JSON konfiguracija",
  "admin.ocenjevalni-listi.validation.filterSubset":
    "Filter za {{label}} je ožji, kot dovoljuje nadrejeni obseg.",
  "admin.ocenjevalni-listi.validation.basic.assessmentTypeRequired":
    "Vrsta ocenjevanja je obvezna.",
  "admin.ocenjevalni-listi.validation.basic.nameSlRequired":
    "Naziv (SL) je obvezen.",
  "admin.ocenjevalni-listi.validation.sections.atLeastOne":
    "Zahtevan je vsaj en sklop.",
  "admin.ocenjevalni-listi.validation.sections.nameSlRequired":
    "Vsak sklop mora imeti naziv (SL).",
  "admin.ocenjevalni-listi.validation.sections.orderRequired":
    "Vsak sklop mora imeti vrstni red.",
  "admin.ocenjevalni-listi.validation.sections.orderSequenceInvalid":
    "Vrstni red sklopov mora biti neprekinjen in se mora začeti z 1.",
  "admin.ocenjevalni-listi.validation.sections.groupRequiredForAll":
    "Če je skupina sklopa določena vsaj pri enem sklopu, mora biti določena pri vseh sklopih.",
  "admin.ocenjevalni-listi.validation.sections.groupNewRequired":
    "Nova skupina sklopa je obvezna.",
  "admin.ocenjevalni-listi.validation.fields.sectionMustContainField":
    "Vsak sklop mora vsebovati vsaj eno polje.",
  "admin.ocenjevalni-listi.validation.fields.nameSlRequired":
    "Vsako polje mora imeti naziv (SL).",
  "admin.ocenjevalni-listi.validation.fields.typeRequired":
    "Vsako polje mora imeti tip.",
  "admin.ocenjevalni-listi.validation.fields.orderRequired":
    "Vsako polje mora imeti vrstni red.",
  "admin.ocenjevalni-listi.validation.fields.orderSequenceInvalid":
    "Vrstni red polj v sklopu mora biti neprekinjen in se mora začeti z 1.",
  "admin.ocenjevalni-listi.validation.fields.lookupRequired":
    "Polja tipa dropdown in radio morajo imeti sifrant ref.",
  "admin.ocenjevalni-listi.validation.fields.numberRangeInvalid":
    "Minimalna številčna vrednost mora biti manjša ali enaka maksimalni.",

  "admin.ocenjevalni-listi.validation.fields.numberRangeNotSet":
    "Razpon dovoljenih ocen ni nastavljen.",
  "admin.ocenjevalni-listi.validation.fields.numberStepNotSet":
    "Korak med dovoljenimi ocenami ni nastavljen.",
  "admin.ocenjevalni-listi.validation.fields.targetValueOutOfRange":
    "Želena vrednost mora biti znotraj razpona med minimalno in maksimalno vrednostjo.",

  "admin.ocenjevalni-listi.validation.customJson.invalidJson":
    "CUSTOM_JSON mora biti veljaven JSON.",
  "admin.ocenjevalni-listi.validation.customJson.invalidObject":
    "CUSTOM_JSON mora biti JSON objekt.",
  "admin.ocenjevalni-listi.validation.customJson.missingType":
    "CUSTOM_JSON mora vsebovati neprazno lastnost type.",
  "admin.ocenjevalni-listi.validation.docxTag.invalidFormat":
    "Docx tag mora biti osnovni ključ brez presledkov in posebnih znakov.",
  "admin.ocenjevalni-listi.validation.docxTag.invalidSuffix":
    "Docx tag mora biti osnovni ključ brez končnic Ocena, Vrednost ali Komentar.",
  copyTemplate: "Kopiraj predlogo",
  "admin.adjustValuesForWool": "Vrednosti za finost volne",
  "admin.wool.list.column.id": "Šifra",
  "admin.wool.list.column.valueFrom": "Vrednost od",
  "admin.wool.list.column.valueTo": "Vrednost do",
  "admin.wool.save": "Shrani finost volne",
  "admin.wool.create": "Dodaj novo vrednost za finost volne",
  "admin.wool.saveSuccess": "Vrednost za finost voljne je bila uspešno vnešena",
  "admin.wool.deleteSuccess":
    "Vrednost za finost volne je bila uspešno izbrisana",
  "admin.lookup-tables.custom": "Posebni šifranti",
  "admin.pripustnaPreiskava.title": "Tipi pripustnih preiskav",
  "admin.pripustnaPreiskava.description":
    "[dog_kop_pripust.pripustna_preiskava] Šifrant tipov pripustnih preiskav ob izdaji pripustnega dovoljenja kopitarju.",
  "admin.pripustnaPreiskava.create": "Dodaj tip preiskave",
  "admin.pripustnaPreiskava.saveSuccess":
    "Tip preiskave je bil uspešno shranjen",
  "admin.pripustnaPreiskava.deactivateSuccess":
    "Tip preiskave je bil označen kot neaktiven.",
  "admin.pripustnaPreiskava.deleteSuccess":
    "Tip preiskave je bil uspešno izbrisan",
  "admin.pripustnaPreiskava.deleteError":
    "Tipa preiskave ni mogoče izbrisati. Tip bo označen kot neaktiven in ne bo prikazan v možnostih izbire.",
  "admin.pripustnaPreiskava.column.naziv": "Naziv",
  "admin.pripustnaPreiskava.column.opis": "Opis",
  "admin.pripustnaPreiskava.column.obveznoEvidentiranje":
    "Obvezno evidentiranje",
  "admin.pripustnaPreiskava.column.disabled": "Neaktivno (onemogočeno)",
  "admin.pripustnaPreiskava.filter.showDisabled": "Pokaži neaktivne",
  "admin.pripustnaSezona.title": "Pripustne sezone",
  "admin.pripustnaSezona.description":
    "[dog_kop_pripust.pripustna_sezona] Šifrant pripustnih sezon kopitarjev.",
  "admin.pripustnaSezona.create": "Dodaj pripustno sezono",
  "admin.pripustnaSezona.saveSuccess":
    "Pripustna sezona je bila uspešno shranjena",
  "admin.pripustnaSezona.deactivateSuccess":
    "Pripustna sezona je bila označena kot neaktivna.",
  "admin.pripustnaSezona.deleteSuccess":
    "Pripustna sezona je bila uspešno izbrisana",
  "admin.pripustnaSezona.deleteError":
    "Pripustne sezone ni mogoče izbrisati. Sezona bo označena kot neaktivna in ne bo prikazana v možnostih izbire.",
  "admin.pripustnaSezona.column.naziv": "Naziv",
  "admin.pripustnaSezona.column.datumZacetek": "Datum začetka",
  "admin.pripustnaSezona.column.datumKonca": "Datum konca",
  "admin.pripustnaSezona.column.disabled": "Neaktivno (onemogočeno)",
  "admin.pripustnaSezona.filter.showDisabled": "Pokaži neaktivne",
  "admin.pripustnaSezona.validation.datumKoncaBeforeZacetek":
    "Datum konca ne sme biti pred datumom začetka",

  "admin.sredstvaZaTretiranje.title": "Sredstva za tretiranje",
  "admin.sredstvaZaTretiranje.description": "Pregled sredstev za tretiranje",
  "admin.sredstvaZaTretiranje.create": "Novo sredstvo",
  "admin.sredstvaZaTretiranje.filter.showDissabled": "Prikaži neaktivne",
  "admin.sredstvaZaTretiranje.naziv": "Naziv",
  "admin.sredstvaZaTretiranje.opis": "Opis",
  "admin.sredstvaZaTretiranje.posebneOpombe": "Posebne opombe",
  "admin.sredstvaZaTretiranje.karenca": "Karenca",
  "admin.sredstvaZaTretiranje.active": "Status",

  "recommended.DA": "Da",
  "recommended.NE": "Ne",
  "required.yes": "Ja",
  "required.no": "Ne",

  "transponder.validation.shortLength":
    "Številka ima manj kot 15 znakov — preverite, ali je pravilna",
  "transponder.validation.longLength":
    "Številka ima več kot 15 znakov — preverite, ali je pravilna",

  "event.bySeed.usesnaStevilka.duplicateWarning":
    "Opozorilo: Ušesna številka že obstaja v bazi! Prosimo, preverite vnesene podatke. Ponovni vnos živali ni dovoljen.",
  "event.outOfControl.izvorId": "Izvor",

  "breeders.title": "Pregled subjektov",
  "breeders.description":
    "Seznam vseh registriranih subjektov v sistemu IS POKK",

  "breeders.form.pageTitle.create": "Registracija novega rejca",
  "breeders.form.pageTitle.edit": "Kartica rejca",
  "breeders.form.pageSubtitle.create":
    "Vnos podatkov za registracijo rejca v sistem IS POKK",
  "breeders.form.pageSubtitle.edit": "Podrobni podatki o rejcu {{name}}",
  "breeders.form.saveErrorUnexpected":
    "Pri shranjevanju je prišlo do nepričakovane napake. Preverite vnesene podatke in poskusite znova.",
  "breeders.form.saveError500":
    "Napaka pri shranjevanju uporabnika. Preverite vsa polja in ponovno shranite.",

  "breeders.tabs.breeders.label": "Rejci",
  "breeders.tabs.responsibilities.label":
    "Dodeljeni zavodi, kontrolorji in selekcionisti",
  "breeders.tabs.programs.label": "Vključitev v rejski program",

  "breeders.table.title": "Seznam rejcev",
  "breeders.list.createButton": "Vnos rejca",
  "breeders.exportCsv": "Izvoz CSV",
  "breeders.responsibilities.table.title":
    "Dodeljeni zavodi, kontrolorji in selekcionisti",
  "breeders.programs.table.title": "Vključitev v rejski program",
  "breeders.list.actionView": "Prikaz kartice rejca",
  "breeders.list.actionEdit": "Uredi rejca",
  "breeders.view.editData": "Uredi podatke",
  "breeders.view.attachmentFallback": "Priponka",
  "breeders.view.enteredBy": "Vnašalec",

  "breeders.fields.sifraRejca": "Šifra rejca",
  "breeders.fields.sifraKopitarji": "Interna šifra rejca (kopitarji)",
  "breeders.fields.sifraPrasici": "Interna šifra rejca (prašiči)",
  "breeders.fields.sifraOvce": "Interna šifra rejca (ovce)",
  "breeders.fields.sifraKoze": "Interna šifra rejca (koze)",
  "breeders.fields.naziv": "Naziv",
  "breeders.fields.nazivPravnaOseba": "Naziv (pravna oseba)",
  "breeders.fields.rejskaOrganizacija": "Rejska organizacija",
  "breeders.fields.ime": "Ime",
  "breeders.fields.priimek": "Priimek",
  "breeders.fields.email": "Elektronski naslov",
  "breeders.fields.telefon": "Kontaktna telefonska številka",
  "breeders.fields.davcnaStevilka": "Davčna številka",
  "breeders.fields.maticnaStevilka": "Matična številka",
  "breeders.fields.emso": "EMŠO",
  "breeders.fields.idSubj": "ID Subjekta",
  "breeders.fields.drobnicaPrivzetNacinZacasneOznacitve":
    "Privzet način začasne označitve živali",
  "breeders.fields.drobnicaPrivzetNacinZacasneOznacitve.POKK_ID": "POKK ID",
  "breeders.fields.drobnicaPrivzetNacinZacasneOznacitve.SIS_PLUS": "SIS+",
  "breeders.fields.osemenjevalniCenter":
    "Opravlja naloge osemenjevalnega centra",
  "breeders.fields.dolocljivKotOdgovorniZavod": "Odgovorni zavod (KGZ)",
  "breeders.fields.soglasjeObjavaKontaktnihPodatkov":
    "Soglasje za objavo kontaktnih podatkov",
  "breeders.fields.soglasjePriloga": "Priloge - izjava o vključitvi",
  "breeders.fields.priloga": "Priloga - soglasje",
  "breeder.sections.naslov": "Naslov rejca",
  "breeder.sections.drugNaslovZaPosiljanje": "Drugi naslov za pošiljanje",
  "breeders.sections.osnovniPodatki": "Osnovni podatki",
  "breeders.sections.osnovniPodatkiSubtitle": "Osnovni podatki o rejcu",
  "breeders.fields.internalBreederCode": "Int. št.",

  "breeders.address.fields.ulica": "Naslov",
  "breeders.address.fields.hisnaStevilka": "Hišna številka",
  "breeders.address.fields.naslovDrugaVrstica": "Naslov druga vrstica",
  "breeders.address.fields.postnaStevilka": "Poštna številka",
  "breeders.address.fields.posta": "Pošta",
  "breeders.address.fields.kraj": "Kraj",
  "breeders.address.fields.drzava": "Država",
  "breeders.address.coordinatesSection": "Zemljepisna širina in dolžina",
  "breeders.address.fields.latitude": "Zemljepisna širina",
  "breeders.address.fields.longitude": "Zemljepisna dolžina",

  "breeders.columns.idSubj": "ID Subj",
  "breeders.columns.label": "Ime Priimek / Naziv",
  "breeders.columns.address": "Naslov",
  "breeders.columns.contact": "Kontaktna številka",
  "breeders.columns.email": "E-pošta",
  "breeders.columns.internalBreederCode": "Int. št.",
  "breeders.columns.rejskaOrganizacija": "Je rejska organizacija",

  "breeders.filters.query": "Splošno iskanje",

  "breeders.map.title": "Grafični prikaz lokacij rejcev na zemljevidu",
  "breeders.map.marker.address": "Naslov rejca",

  "breeders.responsibilities.columns.id_subjekt": "ID Subjekta",
  "breeders.responsibilities.columns.label": "Ime Priimek / Naziv",
  "breeders.responsibilities.columns.contact": "Kontaktna številka",
  "breeders.responsibilities.columns.email": "E-pošta",
  "breeders.responsibilities.columns.species": "Vrsta živali",
  "breeders.responsibilities.columns.institution": "Zavod KGZ",
  "breeders.responsibilities.columns.kontrolor": "Kontrolor",
  "breeders.responsibilities.columns.selekcionist": "Selekcionist",
  "breeders.responsibilities.columns.rejskiProgram": "Rejski program",
  "breeders.responsibilities.columns.datumDodelitve": "Datum dodelitve",
  "breeders.responsibilities.columns.steviloAktivnihZivali":
    "Število aktivnih živali",
  "breeders.responsibilities.validation.duplicateSpeciesZavod":
    "Za isto vrsto živali ne morete izbrati istega zavoda KGZ dvakrat.",
  "breeders.responsibilities.validation.kontrolorRequired":
    "Kontrolor je obvezen za izbrano vrsto živali.",
  "breeders.responsibilities.validation.selekcionistRequired":
    "Selekcionist je obvezen za izbrano vrsto živali.",
  "breeders.responsibilities.actions.add":
    "Dodaj dodelitev zavoda za vrsto živali",
  "breeders.responsibilities.actions.addSelekcionist": "Dodaj selekcionista",
  "breeders.responsibilities.actions.addKontrolor": "Dodaj kontrolorja",
  "breeders.responsibilities.actions.remove": "Izbriši",
  "breeders.responsibilities.delete.title": "Izbris dodelitve zavoda",
  "breeders.responsibilities.delete.confirm":
    "Ali ste prepričani, da želite izbrisati dodelitev zavoda KGZ?",
  "breeders.responsibilities.card.title":
    "Določitev zavoda KGZ za vrsto živali",
  "breeders.responsibilities.card.subtitle":
    "Določitev zavoda, kontrolorjev in selekcionistov za izbrano vrsto živali",
  "breeders.responsibilities.fields.species": "Vrsta živali",
  "breeders.responsibilities.fields.internaSifraRejca": "Interna šifra rejca",
  "breeders.responsibilities.fields.statusRejca": "Status rejca",
  "breeders.responsibilities.fields.zavodKgz": "Zavod KGZ",
  "breeders.responsibilities.fields.selekcionisti": "Selekcionisti",
  "breeders.responsibilities.fields.kontrolorji": "Kontrolorji",
  "breeders.responsibilities.fields.rejskiProgram": "Rejski program",
  "breeders.responsibilities.title": "Rejski program",

  "breeders.programs.columns.sifra_rejca": "Šifra rejca",
  "breeders.programs.columns.label": "Ime Priimek / Naziv",
  "breeders.programs.columns.rejskiProgram": "Rejski program",
  "breeders.programs.columns.datumVstopa": "Datum vstopa",
  "breeders.programs.columns.datumIzstopa": "Datum izstopa",
  "breeders.programs.columns.statusClanstva": "Status članstva",
  "breeders.programs.columns.statusRejca": "Status rejca",
  "breeders.programs.fields.statusRejca": "Status rejca",
  "breeders.programs.columns.rejskePasme": "Pasme",

  "breeders.programs.actions.addForSpecies":
    "Dodaj vključitev v rejski program — {{species}}",
  "breeders.programs.delete.title": "Izbris rejskega programa",
  "breeders.programs.delete.confirm":
    "Ali ste prepričani, da želite izbrisati rejski program?",
  "breeders.programs.hints.selectSpeciesInResponsibilities":
    "Najprej izberite vrsto živali pri dodelitvi zavoda.",
  "breeders.programs.card.titleNumbered": "Vključitev #{{number}}",

  "breeders.programs.card.subtitle":
    "Vključitev rejca v enega ali več rejskih programov.",

  "breeders.programs.hints.selectProgramFirstBreeds":
    "Najprej izberite rejski program. Pasme so omejene na rodovniške knjige tega programa.",
  "breeders.programs.hints.noBreedsForProgram":
    "Za ta rejski program ni najdenih rodovniških knjig ali ustreznih pasem.",

  "breeders.programs.fields.datumVstopa": "Datum vstopa",
  "breeders.programs.fields.datumIzstopa": "Datum izstopa",
  "breeders.programs.fields.usmeritevReje": "Usmeritev reje",
  "breeders.programs.fields.nacinReje": "Način reje",
  "breeders.programs.fields.stalezZenske": "Število ženskih živali v reji",
  "breeders.programs.fields.stalezMoski": "Število moških živali v reji",
  "breeders.programs.fields.stalezSkupno": "Skupno število živali v reji",
  "breeders.programs.fields.soglasjeZaObjavo":
    "Soglasje za objavo podatkov/rezultatov reje",
  "breeders.programs.fields.priloge":
    "Priloge (izjava o vključitvi, izključitvi)",

  "breeders.gmid.title": "Gospodarstva (G-MID)",
  "breeders.gmid.actions.add": "Dodaj novo gospodarstvo (G-MID)",
  "breeders.gmid.fields.cardTitle": "G-MID - {{value}}",
  "breeders.gmid.fields.id": "ID (G-MID)",
  "breeders.gmid.fields.naziv": "Naziv",
  "breeders.gmid.fields.hsMid": "Hišna številka ID (hsMid)",
  "breeders.gmid.fields.centroidLatitude": "Zemljepisna širina",
  "breeders.gmid.fields.centroidLongitude": "Zemljepisna dolžina",
  "breeders.gmid.modal.inspect":
    "Kliknite za pregled in/ali urejanje gospodarstva (G-MID)",
  "breeders.gmid.modal.inpectReadOnly":
    "Kliknite za pregled gospodarstva (G-MID)",
  "breeders.gmid.errors.alreadyExists":
    "Vpisano gospodarstvo (G-MID) že obstaja v sistemu",
  "breeders.kmgMid.errors.alreadyExists": "KMG-MID že obstaja v sistemu",
  "breeders.gmid.modal.add": "Dodaj novo gospodarstvo (G-MID)",
  "validation.breeder.oneGmidRequired":
    "Obvezno je vsaj eno gospodarstvo (G-MID)",
  "validation.breeder.kmgMidRequired": "KMG-MID je obvezen",
  "validation.breeder.address.ulicaRequired": "Naslov je obvezen",
  "validation.breeder.address.hisnaStevilkaRequired":
    "Hišna številka je obvezna",
  "validation.breeder.address.postnaStevilkaRequired":
    "Poštna številka je obvezna",
  "validation.breeder.address.postaRequired": "Pošta je obvezna",
  "validation.breeder.address.drzavaRequired": "Država je obvezna",
  "breeders.gmid.modal.addGmid": "Vnos gospodarstva (G-MID)",
  "breeders.gmid.modal.addNewGmid":
    "Kliknite na + za vnos novega gospodarstva (G-MID)",
  "breeders.gmid.modal.existingGmids": "Vnešena gospodarstva (G-MID)",

  "breeders.view.assignmentsPrograms.title":
    "Dodelitve zavoda in vključitve v rejske programe",
  "breeders.view.assignmentsPrograms.subtitle":
    "Pregled vseh dodelitev zavoda in vključitev rejca v rejske programe",
  "breeders.view.assignmentsPrograms.empty": "Ni vnosov za prikaz.",
  "breeders.view.assignmentsPrograms.sectionInstitution": "Dodelitev zavoda",
  "breeders.view.assignmentsPrograms.sectionProgram":
    "Vključitev v rejski program",
  "breeders.view.assignmentsPrograms.fields.zavod": "Zavod",
  "breeders.view.assignmentsPrograms.fields.soglasjeObjavaReje":
    "Soglasje za objavo podatkov/rezultatov reje",
  "breeders.view.assignmentsPrograms.aktivnihZ": "Trenutno aktivnih živali - Ž",
  "breeders.view.assignmentsPrograms.aktivnihM": "Trenutno aktivnih živali - M",
  "breeders.view.assignmentsPrograms.aktivnihSkupaj":
    "Trenutno aktivnih živali - Skupaj",
  "breeders.view.assignmentsPrograms.steviloObVkljucitvi":
    "Število ob vključitvi",
  "breeders.view.assignmentsPrograms.steviloObVkljucitviValue":
    "Ž: {{z}} M: {{m}} SKUPAJ: {{s}}",
  exportToPdf: "Izvozi v PDF",
  export: "Izvoz",

  "profile.title": "Moj profil",
  "profile.user-details": "Podatki o uporabniku",
  "profile.otp": "2FA",
  "profile.otp.setup": "Nastavi dvofaktorsko avtentikacijo",
  "profile.otp.setupAlreadyDone":
    "Dvofaktorsko avtentikacija je že nastavljena",
  "profile.breeder-details": "Podatki o rejcu",
  "profile.form.field.name": "Ime",
  "profile.form.field.surname": "Priimek",
  "profile.form.field.email": "E-pošta",
  "profile.form.field.username": "Uporabniško ime",

  "profile.form.field.phone": "Telefonska številka",
  "profile.form.sending-address": "Naslov za pošiljanje",
  "profile.form.field.street": "Ulica",
  "profile.form.field.street-no": "Hišna številka",
  "profile.form.field.address-line-2": "Naslov, druga vrstica",
  "profile.form.field.city": "Mesto",
  "profile.form.field.postal-code": "Poštna številka",
  "profile.form.field.country": "Država",

  "table.totalElements_one": "Skupaj: {{count}} vnos",
  "table.totalElements_two": "Skupaj: {{count}} vnosa",
  "table.totalElements_few": "Skupaj: {{count}} vnosi",
  "table.totalElements_other": "Skupaj: {{count}} vnosov",

  izvorRejecNaziv: "Naziv izvornega rejca",
  izvorRejecSifra: "Šifra izvornega rejca",
  izvorRejecKmgMid: "KMG-MID izvornega rejca",
  animal: "žival",
  animals: "živali",

  // --------------------------------------------------------------------------

  "manage-assignments.title": "Dodelitve kontrolorjev in selekcionistov",
  "manage-assignments.description":
    "Upravljanje dodelitev kontrolorjev in selekcionistov za posamezne rejce.",
  "manage-assignments.form.batchEdit.title": "Množično urejanje dodelitev",
  "manage-assignments.form.batchEdit.description":
    "Urejanje dodelitev za {{count}} izbranih rejcev. Spodaj je prikazan seznam vseh trenutnih dodelitev za izbrane rejce.",
  "manage-assignments.form.batchEdit.selectZavod": "Izberi zavod",
  "manage-assignments.form.batchEdit.selectSelekcionist":
    "Izberi selekcionista",
  "manage-assignments.form.batchEdit.selectKontrolor": "Izberi kontrolorja",
  "manage-assignments.columns.animalType": "Vrsta živali",
  "manage-assignments.columns.imeInPriimek": "Ime in priimek / naziv",
  "manage-assignments.columns.internaStevilka": "Interna številka",
  "manage-assignments.form.newTag": "NOVO",
  "manage-assignments.form.new.title": "Nova dodelitev",
  "manage-assignments.form.new": "Nova dodelitev",
  "manage-assignments.form.edit.title": "Uredi dodelitev",
  "manage-assignments.form.edit.description":
    "Urejate dodelitev za rejca: {{breeder}} ({{animalType}})",
  "manage-assignments.form.editSelected": "Uredi izbrane ({{count}})",
  "manage-assignments.form.editSelectedDescription":
    "Urejanje dodelitev za {{count}} izbranih rejcev.",
  "manage-assignments.form.delete.title": "Izbris dodelitve",
  "manage-assignments.form.delete.confirm":
    "Dodelitev za {{speciesNaziv}} se bo odstranila. Želite nadaljevati?",
  "manage-assignments.form.empty.breeders": "Ni izbranih rejcev",
  "manage-assignments.form.empty.selekcionisti": "Ni izbranih selekcionistov",
  "manage-assignments.form.empty.kontrolorji": "Ni izbranih kontrolorjev",
  "manage-assignments.form.removeBreederTooltip": "Odstrani rejca",
  "manage-assignments.form.warning.existingAssignment":
    "Rejec že ima dodelitev za to vrsto živali. Dodelitev je možno samo urejati.",
  "manage-assignments.warning.mixedSpeciesBatchEdit":
    "Množično urejanje je možno samo za dodelitve z isto vrsto živali.",
  "manage-assignments.warning.mixedRejskiProgramBatchEdit":
    "Množično urejanje je možno samo za dodelitve z istim rejskim programom.",
  "manage-assignments.form.removeSelekcionistTooltip": "Odstrani selekcionista",
  "manage-assignments.form.removeKontrolorTooltip": "Odstrani kontrolorja",
  "manage-assignments.form.add.selekcionisti.all":
    "Dodaj selekcionista vsem izbranim rejcem",
  "manage-assignments.form.add.kontrolorji.all":
    "Dodaj kontrolorja vsem izbranim rejcem",
  "manage-assignments.form.batchEdit.selekcionisti.description":
    "Spodaj so prikazani selekcionisti, dodeljeni izbranim rejcem.",
  "manage-assignments.form.batchEdit.kontrolorji.description":
    "Spodaj so prikazani kontrolorji, dodeljeni izbranim rejcem.",
  "manage-assignments.error.unexpected": "Prišlo je do nepričakovane napake.",
  "manage-assignments.success.create": "Dodelitve so bile uspešno shranjene.",
  "manage-assignments.success.edit": "Dodelitve so bile uspešno posodobljene.",
  "manage-assignments.success.batchEdit":
    "Dodelitve za izbrane rejce so bile uspešno posodobljene.",
  "manage-assignments.success.delete": "Dodelitve so bile uspešno izbrisane.",
  "tag.new": "Novo",
  "button.delete": "Izbriši",
  "button.bulkEdit": "Množično urejanje",
  "table.datumDodelitve": "Datum dodelitve",

  "user.edit.warning.title": "Urejanje uporabniških podatkov ni omogočeno",
  "user.edit.warning.content":
    "Podatkov uporabnika v IS POKK ni mogoče spreminjati. Za spremembo imena, priimka, e-poštnega naslova ali drugih uporabniških podatkov se obrnite na skrbnike sistema pri KIS.",

  "breeders.tabs.institutes.label": "Zavodi KGZ",
  "breeders.tabs.inseminationCenter.label": "Osemenjevalni centri",
  "subjects.institute.createButton": "Vnos zavoda KGZ",
  "subjects.inseminationCenter.createButton": "Vnos osemenjevalnega centra",
  "subject.sections.naslov": "Naslov subjekta",
  "subject.address.fields.ulica": "Naslov",
  "subject.address.fields.hisnaStevilka": "Hišna številka",
  "subject.address.fields.naslovDrugaVrstica": "Naslov druga vrstica",
  "subject.address.fields.postnaStevilka": "Poštna številka",
  "subject.address.fields.posta": "Pošta",
  "subject.address.fields.kraj": "Kraj",
  "subject.address.fields.drzava": "Država",
  "subject.address.coordinatesSection": "Zemljepisna širina in dolžina",
  "subject.address.fields.latitude": "Zemljepisna širina",
  "subject.address.fields.longitude": "Zemljepisna dolžina",
  "subject.modal.delete": "Izbris subjekta",
  "subject.modal.deleteConfirmation":
    "Ste prepričani, da želite izbrisati naslednjega subjekta: {{subject}}",
  "subject.institute.table.title": "Seznam zavodov",
  "subject.inseminationCenter.table.title": "Seznam osemenjavalnih centrov",
  "breeders.fields.inseminationCenter": "Osemenjevalni center",

  "geneologyAnalysisType.SNP": "SNP",
  "geneologyAnalysisType.MS": "MS",
  "geneologyAnalysisType.performed": "Metoda genske analize",

  "inbreeding.breed": "Pasma",
};
